import { Auth, DataStore, Predicates, SortDirection, Storage, API, graphqlOperation } from 'aws-amplify';
import AWS from "aws-sdk";
import moment from "moment";
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Column } from 'primereact/column';
import ReactFullscreen from 'react-easyfullscreen';
import { DataTable } from 'primereact/datatable';
import { Dialog } from "primereact/dialog";
import { Dropdown } from 'primereact/dropdown';
import { Image } from 'primereact/image';
import { InputText } from "primereact/inputtext";
import { Sidebar } from 'primereact/sidebar';
import { TabPanel, TabView } from 'primereact/tabview';
import { Tag } from 'primereact/tag';
import { FilterMatchMode, } from 'primereact/api';
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';
import { default as sideBarRight, default as sidebar } from "../../../assets/images/sidebarright.svg";
import awsmobile from "../../../aws-exports";
import Layout from "../../../components/common/nav/initiator/nav.component";
import Editpopup from "../../../components/popup/editpopup";
import { ConvertResponseForEmployee, ConvertResponseForSelect, ConvertResponseOfNameCodeForSelect, GetValueFromArray,graphQLGetAllData } from '../../../helper/commonfunctions';
import { Request_Stipend_Status, stipend_Type, Request_Stipend_Status_Name,STIPEND_DESIG,STIPEND_FORMHISTORY_DESIGNATION } from '../../../helper/enum';
import { ValidatePayrollRole, } from '../../../helper/validateRole';
import { Card } from 'primereact/card';
import { Timeline } from 'primereact/timeline';
import {
  DepartmentTypeMaster,
  Employee,
  Schools, SemisterMaster,
  StipendAssignments,
  StipendMaster,
  YearMaster,
  StipendTransactionCycle
} from "../../../models";
import Login from '../../../setup/auth/login.component';
import '../../../components/reportpdftemplate/base.min.css';
import StipendFormPdf from '../../../components/reportpdftemplate/stipendFormPDF';
import '../../../components/reportpdftemplate/fancy.min.css';
import '../../../components/reportpdftemplate/main.css';
import { USER_TYPES, USER_TYPES_NAMES } from '../../../helper/enum';
import { InputSwitch } from "primereact/inputswitch";
import landing_logo from "../../../assets/images/landing_logo.png";
import { Badge } from 'primereact/badge';
import { dataURLtoBlob } from "../../../components/signature/signatureHelper";
import SignatureDialog from "../../../components/signature/SignatureDialog";
import { handleNotificationsOnStatusChangeforStipendForm } from "../../../components/actions/notficationActions";
import handleDateSelect from '../../../helper/convertDateIntoPSTFormat';
import CheckboxHeader from '../../../components/reportArchive/CheckboxHeader';
import CheckboxColumn from '../../../components/reportArchive/CheckboxColumn';
import CheckArchive from '../../../components/common/CheckArchive';

import * as queries from "../../../graphql/queries";
import * as mutations from "../../../graphql/mutations";

export default function StipendPayrollReportList() {

  let navigateTo = useNavigate();
  const payrollEmail = process.env.REACT_APP_Payroll_Email;
  const ccEmail = process.env.REACT_APP_CC_Email;
  const HREmail = process.env.REACT_APP_HR_Email;

  const loggedStipendPayroll = reactLocalStorage.get('loggedStipendPayroll');
  const currentDateTime = moment();
  //*state
  const componentRef = useRef();
  const [allApproverList, setAllApproverList] = useState([]);
  const [approverList, setApproverList] = useState([]);
  const [approveBtnDisabled, setApproveBtnDisabled] = useState(false);
  const [hideEditButton, setHideEditButton] = useState(false);
  const [employeeId, setEmployeeId] = useState([]);
  const [email, setEmail] = useState(payrollEmail);
  const [employeeCodeOnly, setEmployeeCodeOnly] = useState('');
  const [employeId, setEmployeId] = useState('');
  const [isLoader, setIsLoader] = useState(true);
  const [employeeCode, setEmployeeCode] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [loggedInUserData, setLoggedInUserData] = useState([]);
  const [location, setLocation] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const [transactionCycleReportId, setSubstituteReportId] = useState("");
  const [visibleRequestedReportEdit, setVisibleRequestedReportEdit] = useState(false);
  const [visibleApprovalRequestedReportEdit, setVisibleApprovalRequestedReportEdit] = useState(false);
  const [fullApproverEdit, setFullApproverEdit] = useState(false);
  const [addSignature, setAddSignature] = useState(false);
  const [signature, setSignature] = useState(true);
  const [visibleRequestedReportView, setVisibleRequestedReportView] = useState(false);
  const [rejectVisible, setRejectVisible] = useState(false);
  const [sendMsg, setSendMsg] = useState(false);
  const [rejectMsgValue, setRejectValueMsg] = useState('');
  const [schoolYearArray, setSchoolYearArray] = useState([]);
  const [fallBackApproverId, setFallBackApproverId] = useState();
  const [schoolYearId, setSchoolYearId] = useState('');
  const [schoolYear, setSchoolYear] = useState('');
  const [semisterArray, setSemisterArray] = useState([]);
  const [semisterId, setSemisterId] = useState('');
  const [semister, setSemister] = useState('');
  const [departmentArray, setDepartmentArray] = useState([]);
  const [departmentId, setDepartmentId] = useState('');
  const [departmentPeopleCount, setDepartmentPeopleCount] = useState('');
  const [activeIndex, setActiveIndex] = useState(0);
  const [selfAssign, setSelfAssign] = useState(false);
  const [selectedHRTechnician, setSelectedHRTechnician] = useState(null);
  const [selectedHRTechnicianId, setSelectedHRTechnicianId] = useState(null);
  const [selectedExecutiveManager, setSelectedExecutiveManager] = useState(null);
  const [selectedPrincipal, setSelectedPrincipal] = useState(null);
  const [stipendPayrollReportListInitiator, setStipendPayrollReportListInitiator] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [approvalCompleteData, setApprovalFinalData] = useState([]);
  const [formTitle, setFormTitle] = useState('');
  const [signaturePath, setSignaturePath] = useState(null);
  const [signatureFileAwsPath, setSignatureFileAwsPath] = useState(null);
  const [principleDepartmentHeadList, setPrincipleDepartmentHeadList] = useState([]);
  const [hrList, setHRList] = useState([]);
  const [executiveList, setExecutiveList] = useState([]);
  const [previousEmployee, setPreviousEmployee] = useState('');
  const [approverListForReject, setApproverListForReject] = useState([]);
  const [employeeCodeList, setEmployeeCodeList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [stipendMasterData, setStipendMasterData] = useState([]);
  const [assignmentArray, setAssignmentArray] = useState([{
    "name": "", "amount": "", "isSplit": false, "splitText": "", "isDeptChair": false, "noOfEmployee": "", "isExtraCurricular": false
  }]);

  //states end
  const [fullApproverViewForView, setFullApproverViewForView] = useState(false);
  const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
  const [showNextPopUp, setShowNextPopUp] = useState(false);
  const [confirmVisible2, setConfirmVisible2] = useState(false);
  const [previewSubmit, setPreviewSubmit] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [groupName, setGroupName] = useState();
  const [isAuthenticated, userHasAuthenticated] = useState(true);
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [position, setPosition] = useState('center');
  const [visibleRight, setVisibleRight] = useState(false);
  const [basicInfoPopUp, SetBasicInfoPopUp] = useState(true);
  const [activate, setActivate] = useState("");
  const [previewAndEdit, SetPreviewAndEdit] = useState(false);
  const [stipendMasterId, setStipendMasterId] = useState('');
  const [btnStatus, setBtnStatus] = useState(Request_Stipend_Status.PENDING);
  const [signatureDialog, setSignatureDialog] = useState(false);
  const [approverLevelForReject, setApproverLevelForReject] = useState([]);
  const [schoolList, setSchoolList] = useState([]);
  const [status, setStatus] = useState('');
  const [approverEdit, setApproverEdit] = useState(false);
  let [submittedBy, setSubmittedBy] = useState({});


  //*List
  const [users, SetUsersList] = useState([]);
  const loggedUserId = reactLocalStorage.get('loggedUserId');
  const [statuses] = useState(Request_Stipend_Status_Name);
  const confirmed = stipend_Type;
  const [selectedConfirmation, setSelectedConfirmation] = useState([]);

  const [approversOptions, setApproversOptions] = useState([]);
  const [fallBackApprover, setFallBackApprover] = useState();
  const [fallBackApproverLevel, setFallBackApproverLevel] = useState();
  const [isApproveButtonDisable, setIsApproveButtonDisable] = useState(false);
  
  const [selectedRows, setSelectedRows] = useState([]);
  
  function getArchiveDesignationApprover(currentItem,statusTable) {
	
	
	let archiveDesignation = STIPEND_DESIG.Initiator;
	let HR_TECHNICIAN = statusTable === 'Pending for Prior Approval HR technician- (step 4)'?
 STIPEND_DESIG.PRIOR_HR_TECHNICIAN : statusTable === 'Pending for Assignment Completion HR Technician- (step 6)' ? STIPEND_DESIG.HR_TECHNICIAN_ASSIGNMENT
:  statusTable === "Pending for Completion HR Technician- (step 8)"? STIPEND_DESIG.HR_TECHNICIAN_COMPLETION : STIPEND_DESIG.HR_TECHNICIAN


let principal = statusTable === 'Pending for Prior Approval Principal- (step 3)' ? STIPEND_DESIG.PRINCIPAL :
statusTable === 'Pending for Final Approval Principal- (step 7)' ? STIPEND_DESIG.FINAL_APPROVAL : STIPEND_DESIG.PRINCIPAL

if(currentItem.employeeId === loggedUserId &&
                    statusTable === 'Pending for Approval Employee- (step 2)' ||
                    statusTable === 'Rejected'
                ) {
                   archiveDesignation = STIPEND_DESIG.EMPLOYEE
                }
                else if (currentItem.principalId === loggedUserId &&
                    statusTable === 'Pending for Prior Approval Principal- (step 3)' ||
                    statusTable === 'Pending for Final Approval Principal- (step 7)' ||
                    statusTable === 'Rejected') {
                    archiveDesignation = principal;
                }
                else if (currentItem.hrTechI === loggedUserId &&
                    statusTable === "Pending for Completion HR Technician- (step 8)" ||
                    statusTable === 'Pending for Assignment Completion HR Technician- (step 6)' ||
                    statusTable === 'Pending for Prior Approval HR technician- (step 4)' ||
                    statusTable === "Completed-(step 9)" ||
                    statusTable === 'Rejected') {
                    archiveDesignation = HR_TECHNICIAN;
                }
                else if (currentItem.executiveManagerId === loggedUserId &&
                    statusTable === 'Pending for Approval Excecutive Management- (step 5)' ||
                    statusTable === 'Rejected') {
                    archiveDesignation = STIPEND_DESIG.EXE_DIRECTOR;
                }
                else if (statusTable === 'Pending.- (step 1)') {
                    archiveDesignation = 'Initiator'
                }
               
	return archiveDesignation;
	console.log("archiveDesignation---", statusTable);
	console.log("archiveDesignationapp---", archiveDesignation);
	
}

  //search cognitousers
  const setEmpList = async (e, listName) => {
    try {
      const cognito = new AWS.CognitoIdentityServiceProvider();

      var params =
      {
        UserPoolId: awsmobile.aws_user_pools_id,
        Limit: 60,
        "Filter": "name ^= \"" + e.target.value + "\""
      };

      await cognito.listUsers(params, (err, data) => {
        if (err) {
          //(err.message);
        } else {
          let usersData = []
          //let adminUsers = data.Users
          var role = "";
          var name = "";
          var sub = "";
          var email = "";
          var usercode = "";

          data.Users.forEach((user, i) => {
            role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
            name = user.Attributes.find(attr => attr.Name === "name")?.Value;
            sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
            email = user.Attributes.find(attr => attr.Name === "email")?.Value;
            usercode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
            name = usercode ? `${name} (${usercode})` : name;
            let newUser = {
              "id": sub,
              "name": name,
              "email": email,
              "code": sub,
              "role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
            }

            usersData.push(newUser)

            if (i === data.Users.length - 1) {
              if (listName === 'EMPLOYEE') {
                setEmployeeCodeList(usersData);
              } else if (listName === 'PRINCIPAL') {

                setPrincipleDepartmentHeadList(usersData)
              }
              else if (listName === 'HR') {

                setHRList(usersData)
              } else if (listName === 'EXECUTIVE') {

                setExecutiveList(usersData)
              }
            }
          })
        }
      });

    } catch (e) {
      //toast.error(e.message);
    }
  }


  const setHRManager = async () => {
    try {
      const cognito = new AWS.CognitoIdentityServiceProvider();

      var params =
      {
        UserPoolId: awsmobile.aws_user_pools_id,
        Limit: 60,
        "Filter": "email ^= \"" + HREmail + "\""
      };

      await cognito.listUsers(params, (err, data) => {
        if (err) {
          //(err.message);
        } else {
          let usersData = []
          //let adminUsers = data.Users
          var name = "";
          var sub = "";
          data.Users.forEach((user, i) => {
            name = user.Attributes.find(attr => attr.Name === "name")?.Value;
            sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;

            let objFirst = { name: name, code: sub }
            setSelectedHRTechnician(name)
            setSelectedHRTechnicianId(sub)

          })
        }
      });

    } catch (e) {
      //toast.error(e.message);
    }
  }


  const handleSignatureSelection = async (image) => {
    setSignatureDialog(false);
    setSignatureFileAwsPath(null);
    const signatureFilePath = await uploadSignature(image);
    if (signatureFilePath.trim() !== '') {
      setSignaturePath(signatureFilePath);
      // loadSignatureFile(signatureFilePath);
      setSignatureFileAwsPath(image);
    } else {
      signatureFilePath(null);
    }
  }

  const uploadSignature = async (signature) => {

    const fileName = 'profile/' + loggedInUserData?.userId ?? loggedUserId + '/signature.png';

    const blob = await dataURLtoBlob(signature);

    try {
      toast.loading('Uploading please wait...');
      await Storage.put(fileName, blob, {
        resumable: true,
        completeCallback: (event) => {
          toast.dismiss();
          Auth.currentAuthenticatedUser()
            .then((user) => {
              return Auth.updateUserAttributes(user, {
                'custom:userSignature': fileName,
              });
            }).catch((err) => toast.error(err.message));
        },

        errorCallback: (err) => {
          toast.error(err.message);
        },

      });
      // setSignatureFileAwsPath(signature);
    } catch (error) {
      console.log('Error uploading file: ', error);
    }
    return fileName;
  }

  async function handleRejectClick() {
    getApproverLevelOptions();
  };

  const footerContent = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible(false); setVisibleEdit(false) }}>Close</button>
    </div>
  );
  const footerContent1 = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible2(false); setShowNextPopUp(false); setVisibleCreteReportPopup(false); setShowPreviewPopUp(false); BindList(); }}>Close</button>
    </div>
  );
  //_____popup

  //*state


  const onConfirmationChange = (e) => {
    let _selectedConfirmation = [...selectedConfirmation];
    if (e.checked)
      _selectedConfirmation.push(e.value);
    else
      _selectedConfirmation = _selectedConfirmation.filter(confirmed => confirmed.key !== e.value.key);

    setSelectedConfirmation(_selectedConfirmation);
  };

  //new Request status
  const statusItemTemplate = (option) => {
    return <Tag value={option} severity={TaskStatusSL(option)} />;
  };

  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
    );
  };

  const TaskStatusSLA = (product) => {
    return <><Badge value="" severity={TaskStatusSL(product)}></Badge> {product.status}</>;
  };


  const TaskStatusSL = (product) => {
    switch (product.status) {
      case Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE:
        return 'warning';

      case Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL:
        return 'warning';

      case Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN:
        return 'warning';

      case Request_Stipend_Status.REJECT:
        return 'danger';

      case Request_Stipend_Status.PENDING:
        return 'warning';

      case Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN:
        return 'warning';

      case Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN:
        return 'success';

      case Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL:
        return 'warning';

      case Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN:
        return 'warning';
        
      case Request_Stipend_Status.SUBMITTED:
          return 'info';
		  
		 case Request_Stipend_Status.REVIEWRESUBMITTED:
          return 'info';
		  
		  
		  
        case Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN:
          return 'success';
      case 'Completed':
          return 'success';
      case 'Completed-(step 9)':
          return 'success';
      case Request_Stipend_Status_Name[8]:
          return 'success';  
      default:
        return null;
    }
  };

  const onClickApproverEditData = async () => {
    setApproverEdit(true);
    setFullApproverEdit(false);
    setIsUpdate(true);
    setConfirmVisible2(false);
    SetBasicInfoPopUp(true);
    SetPreviewAndEdit(false);
    // setSelectedHRTechnician('');
    setSelectedExecutiveManager('');
    setSelectedPrincipal('');
    setEmployeeId([]);
    setLocation('');
    setSchoolYearId('');
    setSemisterId('');
    setSelfAssign(false);
    setDepartmentId('');
    setDepartmentPeopleCount('');

    setAssignmentArray([{
      "name": "", "amount": "", "isSplit": false, "splitText": "", "isDeptChair": false, "noOfEmployee": "", "isExtraCurricular": false
    }]);
    setSelectedConfirmation([]);
    setShowNextPopUp(true);

    onClickEditPopUp(stipendMasterId);

  }

  const onClickApproverEditPopUp = async (id) => {
    setApprovalFinalData([]);
    var requestId = id;
    setSubstituteReportId(requestId);
    SetPreviewAndEdit(false);

    const substituteCertificateRequestTransactionCycleResponse = await DataStore.query(StipendTransactionCycle, requestId);

    setStipendMasterId(substituteCertificateRequestTransactionCycleResponse.report_Id);

    if (substituteCertificateRequestTransactionCycleResponse.isApproved === true) {
      setIsApproveButtonDisable(true);
    }

    // setShowNextPopUp(true);
    const stipendRequestResponse = await DataStore.query(StipendMaster, (c) => c.id.eq(substituteCertificateRequestTransactionCycleResponse.report_Id));

    if (stipendRequestResponse[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT) {
      setHideEditButton(true)
    }

    //Get stipend details
    getStipendFormDetails(stipendRequestResponse[0].id)

    //---Start Approval Status-----
    getApprovalData(stipendRequestResponse[0].id);

  }


  const onClickEditPopUp = async (id) => {
    setConfirmVisible2(false)
    SetBasicInfoPopUp(true)
    SetPreviewAndEdit(false)

    const cognito = new AWS.CognitoIdentityServiceProvider();

    var requestId = id;
    const original = await DataStore.query(StipendMaster, requestId);

    setStipendMasterId(requestId)
    setPreviousEmployee(original.employeeId);

    if (original) {

      setFormTitle(original.title)
      let employee = await DataStore.query(Employee, original.employeeId);

      const school = await DataStore.query(Schools, original.schoolId);
      const schoolYear = await DataStore.query(YearMaster, original.schoolYearId);
      const semister = await DataStore.query(SemisterMaster, original.semisterId);
      /* const departmentType = await DataStore.query(DepartmentTypeMaster, original.departmentTypeId);
      setDepartmentPeopleCount(original.peopleCountInDepartment)
      setSelfAssign(original.selfAssignment) */

      if (original.statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT) {
        setHideEditButton(false)
      }

      if (employee) {
        setEmployeeId({ "name": employee.employee_name + " (" + employee.employee_code + ")", "code": employee.id })
        setEmployeeCodeOnly(employee.employee_code)
      }

      if (school)
        setLocation({ "name": school.name, "code": school.id })

      if (schoolYear)
        setSchoolYearId({ "name": schoolYear.name, "code": schoolYear.id })
      if (semister)
        setSemisterId({ "name": semister.name, "code": semister.id })

      setBtnStatus(original.statusStipend)

      if (original.statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE || original.statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL || original.statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN || original.statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT || original.statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN || original.statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL || original.statusStipend === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN || original.statusStipend === Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN || original.statusStipend === Request_Stipend_Status.REJECT) {
        setBtnDisabled(true)
      }

      let selectedConfirmationType = [];

      if (original.isMiddleStipend === true) {
        selectedConfirmationType.push({ name: 'Middle School Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isMiddleStipend' });
      }
      if (original.isElementaryStipend === true) {
        selectedConfirmationType.push({ name: 'Elementary Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isElementaryStipend' });
      }
      if (original.isHighStipend === true) {
        selectedConfirmationType.push({ name: 'High School Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isHighStipend' });
      }
      if (original.isDepartmentStipend === true) {
        selectedConfirmationType.push({ name: 'Department Chair Stipend(01.0-00000.0-11303-10000-1170-0005616)(01.0-65000.0-57606-11100-1170-0000600-SPED)', key: 'isDepartmentStipend' });
      }
      if (original.isHeadStipend === true) {
        selectedConfirmationType.push({ name: 'Head Counselor Stipend(01.0-00000.0-00000-31101-1272-0004682)', key: 'isHeadStipend' });
      }
      setSelectedConfirmation(selectedConfirmationType)

      let assignments = await DataStore.query(StipendAssignments, (c) => c.stipendMasterId.eq(requestId));

      var myArray = [];
      if (assignments.length > 0) {
        for (let i = 0; i < assignments.length; i++) {
          myArray.push({ "name": assignments[i].name, "amount": assignments[i].amount, "isSplit": assignments[i].isSplit, "splitText": assignments[i].splitText, "isDeptChair": assignments[i].isDeptChair, "noOfEmployee": assignments[i].noOfEmployee, "isExtraCurricular": assignments[i].isExtraCurricular })
        }
        setAssignmentArray(myArray)
      }

      //get Principle Department Head 

      if (original.principalId) {

        let empName = await DataStore.query(Employee, (c) => c.user_Id.eq(original.principalId));
        let name = empName[0].employee_code ? `${empName[0].employee_name} (${empName[0].employee_code})` : empName[0].employee_name;

        let objFirst = { name: name, code: original.principalId }
        setSelectedPrincipal(objFirst)
      }



      //get HR Technician
      let HRTechnician = '';
      if (original.hrTechI) {
        try {
          HRTechnician = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: original.hrTechI }).promise();
        } catch (e) {
          //console.log(e)
        }

        let hRTechnicianApprovalFirstName = await GetValueFromArray(HRTechnician.UserAttributes, "custom:firstName")
        let hRTechnicianApprovalLastName = await GetValueFromArray(HRTechnician.UserAttributes, "custom:lastName")
        let fullhRTechnicianName = hRTechnicianApprovalFirstName + " " + hRTechnicianApprovalLastName
        let objFirst = { name: fullhRTechnicianName, code: original.hrTechI }
        setSelectedHRTechnician(fullhRTechnicianName)
        setSelectedHRTechnicianId(original.hrTechI)
        setHRList([objFirst])
      }

      //get Executive Management
      if (original.executiveManagerId) {

        let empName = await DataStore.query(Employee, (c) => c.user_Id.eq(original.executiveManagerId));
        let name = empName[0].employee_code ? `${empName[0].employee_name} (${empName[0].employee_code})` : empName[0].employee_name;

        let objFirst = { name: name, code: original.executiveManagerId }
        setSelectedExecutiveManager(objFirst)
      }

      /*  if (departmentType)
      setDepartmentId({ "name": departmentType.name, "code": departmentType.id }) */

      setShowNextPopUp(true);
    }
  }

  const getApproverLevelOptions = async () => {
    const cognito = new AWS.CognitoIdentityServiceProvider();

    const original = await DataStore.query(StipendMaster, c =>
      c.id.eq(stipendMasterId)
    );

    console.log(original[0].statusStipend)
    const originalEmployee = await DataStore.query(Employee, c =>
      c.id.eq(original[0].employeeId)
    );

    try {
      if (original.length) {
        // const approversArrray = [original[0].createdBy, originalEmployee[0].user_Id, original[0].executiveManagerId, original[0].hrTechI, original[0].principalId];

        const approverOption = [];
        const levelOption = [];
        let employeeData = '';

        //Employee
        if (originalEmployee[0].user_Id) {
          try {
            employeeData = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: originalEmployee[0].user_Id }).promise();
          } catch (e) {
            //console.log(e)
          }
          let firstApprovalFirstName = await GetValueFromArray(employeeData.UserAttributes, "custom:firstName")
          let firstApprovalLastName = await GetValueFromArray(employeeData.UserAttributes, "custom:lastName")
          let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName
          let objFirst = { label: fullFirstName, value: originalEmployee[0].user_Id, type: "Employee", key: "E" }

          approverOption.push(objFirst);
        }

        let createdByUser = '';

        //Initiator -
        if (original[0].createdBy) {
          try {
            createdByUser = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: original[0].createdBy }).promise();
          } catch (e) {
            //console.log(e)
          }
          let firstApprovalFirstName = await GetValueFromArray(createdByUser.UserAttributes, "custom:firstName")
          let firstApprovalLastName = await GetValueFromArray(createdByUser.UserAttributes, "custom:lastName")
          let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName;
          let objFirst = { label: fullFirstName, value: original[0].createdBy, type: "Initiator", key: "I" }
          approverOption.push(objFirst);
        }

        let principalUser = '';
        if (original[0].principalId) {
          try {
            principalUser = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: original[0].principalId }).promise();
          } catch (e) {
            //console.log(e)
          }
          let firstApprovalFirstName = await GetValueFromArray(principalUser.UserAttributes, "custom:firstName")
          let firstApprovalLastName = await GetValueFromArray(principalUser.UserAttributes, "custom:lastName")
          let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName
          let objFirst = { label: fullFirstName, value: original[0].principalId, type: "Principal", key: "P" }

          approverOption.push(objFirst);

        }


        let hrTechUser = '';
        if (original[0].hrTechI) {
          try {
            hrTechUser = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: original[0].hrTechI }).promise();
          } catch (e) {
            //console.log(e)
          }
          let firstApprovalFirstName = await GetValueFromArray(hrTechUser.UserAttributes, "custom:firstName")
          let firstApprovalLastName = await GetValueFromArray(hrTechUser.UserAttributes, "custom:lastName")
          let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName
          let objFirst = { label: fullFirstName, value: original[0].hrTechI, type: "HR", key: "H" }
          approverOption.push(objFirst);
        }

        let executiveManagerUser = '';

        if (original[0].executiveManagerId) {
          try {
            executiveManagerUser = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: original[0].executiveManagerId }).promise();
          } catch (e) {
            //console.log(e)
          }
          let firstApprovalFirstName = await GetValueFromArray(executiveManagerUser.UserAttributes, "custom:firstName")
          let firstApprovalLastName = await GetValueFromArray(executiveManagerUser.UserAttributes, "custom:lastName")
          let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName
          let objFirst = { label: fullFirstName, value: original[0].executiveManagerId, type: "Executive", key: "EM" }
          approverOption.push(objFirst);
        }

        let approveFinalArray = [];

        for (let i = 0; i < approverOption.length; i++) {
          if (approverOption[i].type === "Initiator") {
            if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN) {
              approveFinalArray.push(approverOption[i]);
            }
          }

          if (approverOption[i].type === "Employee") {

            if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN) {

              approveFinalArray.push(approverOption[i]);
            }

          }
          if (approverOption[i].type === "Principal") {

            if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN) {

              approveFinalArray.push(approverOption[i]);
            }
          }
          if (approverOption[i].type === "HR") {
            if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT) {
              approveFinalArray.push(approverOption[i]);
            }
          }

          if (approverOption[i].type === "Executive") {
            if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN) {
              approveFinalArray.push(approverOption[i]);

            }
          }
        }

        if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE) {
          levelOption.push({ label: 'Initiator', value: 'I' });
        }

        else if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL) {
          levelOption.push({ label: 'Initiator', value: 'I' }); //, { label: 'Employee', value: 'E' }
        }

        else if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN) {
          levelOption.push({ label: 'Initiator', value: 'I' },); //{ label: 'Employee', value: 'E' }, { label: 'Principal', value: 'P' }
        }

        else if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT) {
          levelOption.push({ label: 'Initiator', value: 'I' }, { label: 'HR', value: 'H' }); //{ label: 'Employee', value: 'E' }, { label: 'Principal', value: 'P' },
        }
        else if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN) {
          levelOption.push({ label: 'Initiator', value: 'I' }, { label: 'Executive Management', value: 'EM' }); //{ label: 'Employee', value: 'E' }, { label: 'Principal', value: 'P' }, 

        }

        else if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN || original[0].statusStipend === Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN) {
          levelOption.push({ label: 'Initiator', value: 'I' }, { label: 'Executive Management', value: 'EM' }); //{ label: 'Employee', value: 'E' }, { label: 'Principal', value: 'P' },

        }
        else if (original[0].statusStipend === Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL) {
          levelOption.push({ label: 'Initiator', value: 'I' }, { label: 'Executive Management', value: 'EM' }, { label: 'HR', value: 'H' }); //{ label: 'Employee', value: 'E' },{ label: 'Principal', value: 'P' },
        }
        setApproversOptions(approveFinalArray);
        setApproverLevelForReject(levelOption);
      }
    }
    catch (e) {
      console.log(e, 'erooorrr');
    }
  }


  const getApprover = async (e) => {
    setFallBackApproverLevel(e)
    for (let i = 0; i < approversOptions.length; i++) {
      if (e === approversOptions[i].key) {
        setFallBackApprover(approversOptions[i].label);
        setFallBackApproverId(approversOptions[i].value);
      }
    }
  }

  const toggleActive = () => {
    setActivate(activate === "actives" ? "" : "actives");
  };

  async function onLoad() {
    try {
      await Auth.currentSession();
      if (!ValidatePayrollRole()) { userHasAuthenticated(false); }
    } catch (e) {
      userHasAuthenticated(false);
    }
  }



  //*Save Basic info
  const saveBasicInfo = async (status) => {
    setBtnDisabled(true);

    let isElementaryStipend = false;
    let isMiddleStipend = false;
    let isHighStipend = false;
    let isDepartmentStipend = false;
    let isHeadStipend = false;

    for (let i = 0; i < selectedConfirmation.length; i++) {
      if (selectedConfirmation[i].key === 'isElementaryStipend') { isElementaryStipend = true }
      if (selectedConfirmation[i].key === 'isMiddleStipend') { isMiddleStipend = true }
      if (selectedConfirmation[i].key === 'isHighStipend') { isHighStipend = true }
      if (selectedConfirmation[i].key === 'isDepartmentStipend') { isDepartmentStipend = true }
      if (selectedConfirmation[i].key === 'isHeadStipend') { isHeadStipend = true }
    }

    if (!employeeId) { toast.error('Please Enter Employee Id.'); return; }
    if (!formTitle) { toast.error('Please Enter Form Title.'); return; }

    else if (!location) { toast.error('Please Select School.'); return; }
    else if (!schoolYearId) { toast.error('Please Select School Year.'); return; }
    else if (!semisterId) { toast.error('Please Select Semester.'); return; }
    else if (!selectedPrincipal) { toast.error('Please Select Principal.'); return; }
    else if (!selectedHRTechnicianId) { toast.error('Please Select HR Technician.'); return; }
    else if (!selectedExecutiveManager) { toast.error('Please Select Executive Manager.'); return; }

    /*  else if (!departmentId) { toast.error('Please Select Department Type'); return; }
     else if (!departmentPeopleCount) { toast.error('Please Enter no. of people in the Department'); return; } */

    if (isUpdate) {

      const original = await DataStore.query(StipendMaster, stipendMasterId);

      const save = await DataStore.save(
        StipendMaster.copyOf(original, (updated) => {
          // updated.employeeId = employeeId.code;
          updated.schoolId = location.code;
          updated.schoolYearId = schoolYearId.code;
          updated.semisterId = semisterId.code;
          updated.selfAssignment = 0; //selfAssign;
          updated.departmentTypeId = '' + ' '; //departmentId.code;
          updated.peopleCountInDepartment = ''; //departmentPeopleCount;
          updated.isElementaryStipend = isElementaryStipend;
          updated.isMiddleStipend = isMiddleStipend;
          updated.isHighStipend = isHighStipend;
          updated.isDepartmentStipend = isDepartmentStipend;
          updated.isHeadStipend = isHeadStipend;
          updated.principalId = selectedPrincipal.code;
          updated.hrTechI = selectedHRTechnicianId ? selectedHRTechnicianId : '';
          updated.executiveManagerId = selectedExecutiveManager ? selectedExecutiveManager.code : '';
          updated.title = formTitle;
          updated.updatedBy = loggedUserId;

        })
      ).then(async (response) => {
        await DataStore.delete(StipendAssignments, (c) => c.stipendMasterId.eq(response.id)).then(async () => {
          assignmentArray.map(async (item) => {
            if (item.name || item.amount) {
              await DataStore.save(
                new StipendAssignments({
                  "stipendMasterId": response.id,
                  "name": item.name,
                  "amount": item.amount,
                  "isSplit": item.isSplit,
                  "splitText": item.splitText,
                  "isDeptChair": item.isDeptChair,
                  "noOfEmployee": item.noOfEmployee,
                  "isExtraCurricular": item.isExtraCurricular
                })
              )
            }
          })
        });

        setEmployeeId([])
        setEmployeeCodeOnly([])
        setLocation('')
        setSchoolYearId('')
        setFormTitle('')
        setSelectedConfirmation([])
        setSemisterId('')
        setPreviousEmployee('')
        setShowNextPopUp(false);
        // setEmail('')

      })

      // || previewSubmit === true
      if (status === Request_Stipend_Status.PENDING) {
        toast.success("Successfully Saved.");
      }

      if (status === Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE) {
        setStipendMasterData([])
        setShowPreviewPopUp(false);
        setShowNextPopUp(false)
        BindList();
        toast.success("Successfully Submitted.");
      }

    }

    setBtnDisabled(false);
  }

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region,
  });

  const CounterAction = (row, index) => {
    return (
      (index.rowIndex) + 1
    );
  };

  //action layout code start
  const approverReportAction = (row) => {
    return (
      <div className="flex justify-center w-full gap-2" >

        {
          row.isApproved || (row.statusCycle === Request_Stipend_Status.REJECT && (row.rejectedBy === 'I' || row.rejectedBy === 'E' || row.rejectedBy === 'EM' || row.rejectedBy === 'P' || row.rejectedBy === 'false')) || row.status === Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN
            ? <Link to='#' className="py-2 px-2.5"
              onClick={() => {
                onClickRequestedReportViewPopup(row, 'right');
              }}
            ><i className="gusd-eye text-[18px] text-[#667085] font-meduim"></i></Link> :
            (row.rejectedBy === 'H') || row.status === Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN || row.status === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN || row.status === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN ? <Link to='#' className="py-2 px-2.5" onClick={() => { //PENDING_FOR_APPROVAL_EMPLOYEE
              setVisibleApprovalRequestedReportEdit(true);
              onClickApproverEditPopUp(row.id);
            }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> : 
			<Link to='#' className="py-2 px-2.5"
              onClick={() => {
                onClickRequestedReportViewPopup(row, 'right');
              }}
            ><i className="gusd-eye text-[18px] text-[#667085] font-meduim"></i></Link>

        }
      </div>
    );
  };

  const approvalStatusBody = (product) => {
    return <Tag value={product.status} severity={approveStatusOptions(product)}></Tag>;
  };

  const approveStatusOptions = (product) => {

    switch (product.status) {
      case Request_Stipend_Status.REJECT:
        return 'danger';

      case Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE:
        return 'warning';
      case Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL:
        return 'warning';
      case Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN:
        return 'warning';
      case Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT:
        return 'warning';
      case Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN:
        return 'warning';
      case Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL:
        return 'warning';
      case Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN:
        return 'warning';
      case Request_Stipend_Status.PENDING:
        return 'warning';
      case Request_Stipend_Status.SUBMITTED:
        return 'info';
		
		case Request_Stipend_Status.REVIEWRESUBMITTED:
          return 'info';
		  
      case "Approved":
        return 'success';
      
      case Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN:
          return 'success';
        

      default:
        return null;
    }
  };

  //approve report function
  const approveSelectedReport = async (reportId, status) => {

    //For HR there is 4 times approval
    /* =============================================== */
    //1.PENDING_FOR_APPROVAL_HR_TECHNICIAN
    //2.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN
    //3.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN
    //4.ACKNOWLEDGMENT_HR_TECHNICIAN
    /* =============================================== */

    //get reporting manager from stipend table
    if (status === Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN) {
      try {
        if (!addSignature) {
          toast.error('Please add the signature.'); return;
        }
        setApproveBtnDisabled(true);
        //get latest cycle from StipendTransactionCycle table
        const transactionCycleResponse = await DataStore.query(StipendTransactionCycle, reportId);

        const stipendMasterReport = await DataStore.query(StipendMaster, transactionCycleResponse.report_Id);

        //1.PENDING_FOR_APPROVAL_HR_TECHNICIAN
        if (transactionCycleResponse.status === Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN) {

          await DataStore.save(
            StipendTransactionCycle.copyOf(transactionCycleResponse, (updated) => {
              updated.isApproved = true;
              updated.signature_File_Path = signaturePath;
              // updated.status = Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT;
              updated.submittedDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
            })
          ).then(async (response) => {

            //after we add another row for save report id for reporting managers approver
            const addNewRowForRMReasponse = await DataStore.save(
              new StipendTransactionCycle({
                report_Id: stipendMasterReport.id,
                from_Employee_Id: loggedUserId,
                to_Employee_Id: stipendMasterReport.executiveManagerId,
                status: Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT,
				toEmployeeDesignation: STIPEND_FORMHISTORY_DESIGNATION.EXE_DIRECTOR, 
                isApproved: false,
                remark: "",
                submittedDate: moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
              })
            );

            await DataStore.save(
              StipendMaster.copyOf(stipendMasterReport, (updated) => {
                updated.statusStipend = Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT;
                updated.rejectedBy = 'false';
                updated.date = moment().format("YYYY-MM-DD");
              })
            )
            await handleNotificationsOnStatusChangeforStipendForm('PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT', stipendMasterReport.id, "STIPENDS_FORM", stipendMasterReport.executiveManagerId, loggedUserId);
            await handleNotificationsOnStatusChangeforStipendForm(Request_Stipend_Status.APPROVEDBY, stipendMasterReport.id, "STIPENDS_FORM", stipendMasterReport.createdBy, loggedUserId);
          })

        }
        //2.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN
        else if (transactionCycleResponse.status === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN) {

          await DataStore.save(
            StipendTransactionCycle.copyOf(transactionCycleResponse, (updated) => {
              updated.isApproved = true;
              updated.signature_File_Path = signaturePath;
              // updated.status = Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL;
              updated.submittedDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
            })
          ).then(async (response) => {

            //after we add another row for save report id for reporting managers approver
            const addNewRowForRMReasponse = await DataStore.save(
              new StipendTransactionCycle({
                report_Id: stipendMasterReport.id,
                from_Employee_Id: loggedUserId,
                to_Employee_Id: stipendMasterReport.principalId,
                status: Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL,
				toEmployeeDesignation: STIPEND_FORMHISTORY_DESIGNATION.PRINCIPAL, 
                isApproved: false,
                remark: "",
                submittedDate: moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
              })
            );

            await handleNotificationsOnStatusChangeforStipendForm('PENDING_FOR_APPROVAL_FINAL_APPROVAL', stipendMasterReport.id, "STIPENDS_FORM", stipendMasterReport.principalId, loggedUserId);
            await handleNotificationsOnStatusChangeforStipendForm(Request_Stipend_Status.APPROVEDBY, stipendMasterReport.id, "STIPENDS_FORM", stipendMasterReport.createdBy, loggedUserId);
            await DataStore.save(
              StipendMaster.copyOf(stipendMasterReport, (updated) => {
                updated.statusStipend = Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL;
                updated.rejectedBy = 'false';
                updated.date = moment().format("YYYY-MM-DD");
              })
            )
          })

        }
        //3.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN
        else if (transactionCycleResponse.status === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN) {

          await DataStore.save(
            StipendTransactionCycle.copyOf(transactionCycleResponse, (updated) => {
              updated.isApproved = true;
              updated.ccEmail = email;
              updated.signature_File_Path = signaturePath;
              // updated.status = Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN;
              updated.submittedDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
            })
          ).then(async (response) => {

            //after we add another row for save report id for reporting managers approver
            const addNewRowForRMReasponse = await DataStore.save(
              new StipendTransactionCycle({
                report_Id: stipendMasterReport.id,
                from_Employee_Id: loggedUserId,
                to_Employee_Id: stipendMasterReport.hrTechI,
                status: Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN,
				toEmployeeDesignation: STIPEND_FORMHISTORY_DESIGNATION.HR_TECHNICIAN, 
                isApproved: false,
                remark: "",
                submittedDate: moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
              })
            );

            //
            let ccEmail = [email];
            await handleNotificationsOnStatusChangeforStipendForm('ACKNOWLEDGMENT_HR_TECHNICIAN', stipendMasterReport.id, "STIPENDS_FORM", stipendMasterReport.hrTechI, loggedUserId, ccEmail);

            await handleNotificationsOnStatusChangeforStipendForm('COMPLETED', stipendMasterReport.id, "STIPENDS_FORM", stipendMasterReport.createdBy, loggedUserId);

            await DataStore.save(
              StipendMaster.copyOf(stipendMasterReport, (updated) => {
                updated.statusStipend = Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN;
                updated.rejectedBy = 'false';
                updated.date = moment().format("YYYY-MM-DD");
              })
            )

          })

        }
        //4.ACKNOWLEDGMENT_HR_TECHNICIAN
        else if (transactionCycleResponse.status === Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN) {
          await DataStore.save(
            StipendTransactionCycle.copyOf(transactionCycleResponse, (updated) => {
              updated.isApproved = true;
              updated.signature_File_Path = signaturePath;
              // updated.status = Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN;
              updated.submittedDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
            })
          );
          await DataStore.save(
            StipendMaster.copyOf(stipendMasterReport, (updated) => {
              updated.statusStipend = Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN;
              updated.rejectedBy = 'false';
              updated.date = moment().format("YYYY-MM-DD");
            })
          )
        }

        toast.success('Approved.');
        setStipendPayrollReportListInitiator([]);
        BindList();

      }
      catch (err) {
        console.log(err + 'approveSelectedReport error');
      }

    }
    else if (status === Request_Stipend_Status.REJECT) {
      try {
        setApproveBtnDisabled(false);
        const original = await DataStore.query(StipendTransactionCycle, reportId);

        const latestStipendTransactionCycle = await DataStore.query(StipendTransactionCycle, c =>
          c.report_Id.eq(original.report_Id), { sort: s => s.createdAt(SortDirection.DESCENDING) }
        );

        let toEmployeeStatus = '';
        let masterStatus = '';

        //Initiator- I , Employee-E, Principal-P,  Executive Management- EM, HR-H

        if (fallBackApproverLevel === 'I') {
          toEmployeeStatus = Request_Stipend_Status.PENDING;
          masterStatus = Request_Stipend_Status.REJECT;
        }
        if (fallBackApproverLevel === 'E') {
          toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE
        }
        else if (fallBackApproverLevel === 'P') {

          if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN) {
            toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL;
          } else {
            toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL;
          }

        } else if (fallBackApproverLevel === 'EM') {
          toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT
        } else if (fallBackApproverLevel === 'H') {

          if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN) {
            toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN
          } else if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN) {
            toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN
          } else if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN) {
            toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN
          }
          else if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT) {
            toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN
          }
          else if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL) {
            toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN
          }
        }

        await DataStore.save(
          StipendTransactionCycle.copyOf(original, (updated) => {
            updated.status = Request_Stipend_Status.REJECT;
            updated.remark = rejectMsgValue;
            updated.rejectedBy = loggedUserId;
            updated.submittedDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
          })
        ).then(async (response) => {

          const stipendMasterReport = await DataStore.query(StipendMaster, original.report_Id);

          await DataStore.save(
            StipendMaster.copyOf(stipendMasterReport, (updated) => {
              updated.statusStipend = Request_Stipend_Status.REJECT;
              updated.remark = rejectMsgValue;
              updated.rejectedBy = fallBackApproverLevel;
              updated.date = moment().format("YYYY-MM-DD");
            })
          )

          //after we add another row for save report id for reporting managers approver

          if (fallBackApproverLevel === 'H' || fallBackApproverLevel === 'EM' || fallBackApproverLevel === 'I') {

            const addNewRowForRMReasponse = await DataStore.save(
              new StipendTransactionCycle({
                report_Id: stipendMasterReport.id,
                from_Employee_Id: loggedUserId,
                to_Employee_Id: fallBackApproverId,
                status: toEmployeeStatus,
                isApproved: false,
                remark: rejectMsgValue,
                submittedDate: moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
              })
            );
          }

          const cognito = new AWS.CognitoIdentityServiceProvider();
          let createdByData = [];

          try {
            createdByData = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: stipendMasterReport.createdBy }).promise();
          } catch (e) {
            //console.log(e)
          }
          let initiatorEmail = await GetValueFromArray(createdByData.UserAttributes, "email")

          const emails = [initiatorEmail];

          //For initiator
          await handleNotificationsOnStatusChangeforStipendForm(Request_Stipend_Status.REJECT, stipendMasterReport.id, "STIPENDS_FORM", stipendMasterReport.createdBy, loggedUserId, emails, rejectMsgValue);

          //For selected approver - give whitelabel
          if (fallBackApproverLevel !== 'I') {
            await handleNotificationsOnStatusChangeforStipendForm(Request_Stipend_Status.REJECT, stipendMasterReport.id, "STIPENDS_FORM", fallBackApproverId, loggedUserId, emails, rejectMsgValue);
          }
          setRejectValueMsg("");
          setStipendPayrollReportListInitiator([]);
          BindList();
        })
      }
      catch (err) {
      }
    }

    setVisibleApprovalRequestedReportEdit(false);
    setApproveBtnDisabled(false);
  }

  //* onclick view popup - Approver
  const onClickRequestedReportViewPopup = async (requestData, position) => {
    try {

      const particularReportTransactionCycleResponse = await DataStore.query(StipendTransactionCycle, requestData.id);

      getStipendFormDetails(particularReportTransactionCycleResponse.report_Id);
      getApprovalData(particularReportTransactionCycleResponse.report_Id);

    } catch (err) {
      console.log("Error in onClickInitiateRequestViewPopup", err);
    }

    //---------------
    setPosition(position);
    setVisibleRequestedReportView(true);

  }

  const getApprovalData = async (reportId) => {

    let approvalFinalData = [];
    let formHistoryFinalData = [];
    let fullName;
    let userCodeEmp = '';

    const particularReportTransactionCycleResponseLatest = await DataStore.query(StipendTransactionCycle, c =>
      c.report_Id.eq(reportId), { sort: s => s.createdAt(SortDirection.ASCENDING) }
    );

    const stipendMasterData = await DataStore.query(StipendMaster, reportId);


    const cognito = new AWS.CognitoIdentityServiceProvider();
    //fetch user data
    var newRes = []
    let userRole = '', userName = '', userEmail = '', userCode = '', sub;
    users.forEach((user, i) => {

      userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
      sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
      userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
      userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
      userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

      let obj = {
        "userId": sub,
        "name": userName,
        "email": userEmail,
        "usercode": userCode,
        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
      }
      newRes.push(obj);
    }
    );


    //---Start Approval Status-----
    let adminUsers;
    if (particularReportTransactionCycleResponseLatest[0].to_Employee_Id) {
      try {
        adminUsers = await cognito.adminGetUser({
          UserPoolId: awsmobile.aws_user_pools_id,
          Username: particularReportTransactionCycleResponseLatest[0].to_Employee_Id,
        }).promise();
      } catch (e) {
        //console.log(e)
      }
    }


    let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : '';
    let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
    userCodeEmp = await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode")
    fullName = userFirstName + " " + userLastName;

    if (particularReportTransactionCycleResponseLatest) {
      //get name of user from 'to_Employee_Id'
      for (let i = 0; i < particularReportTransactionCycleResponseLatest.length; i++) {
        let empName = '', empCode = '';

        for (let j = 0; j < newRes.length; j++) {
          let currentItem = newRes[j];
          if (currentItem.userId == particularReportTransactionCycleResponseLatest[i].to_Employee_Id) {
            empName = currentItem.name;
            empCode = currentItem.usercode;
            break;
          }
        }

        let adminUsers;
        if (particularReportTransactionCycleResponseLatest[i].to_Employee_Id) {
          try {
            adminUsers = await cognito.adminGetUser({
              UserPoolId: awsmobile.aws_user_pools_id,
              Username: particularReportTransactionCycleResponseLatest[i].to_Employee_Id,
            }).promise();
          } catch (e) {
            //console.log(e)
          }
        }


        let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
        let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
        let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : ''
        let fullName = userFirstName + " " + userLastName

        let dateTime = particularReportTransactionCycleResponseLatest[i].status === "Completed-(step 9)" ||
          particularReportTransactionCycleResponseLatest[i].isApproved ||
		  particularReportTransactionCycleResponseLatest[i].status ===  Request_Stipend_Status.REVIEWRESUBMITTED ||
          particularReportTransactionCycleResponseLatest[i].status === "Rejected" ?
          (particularReportTransactionCycleResponseLatest[i].submittedDate ?
            handleDateSelect(particularReportTransactionCycleResponseLatest[i].submittedDate)
            : moment(currentDateTime).toISOString()) : null;

           
            let empTitle = '';

            if(stipendMasterData.employeeId === particularReportTransactionCycleResponseLatest[i].to_Employee_Id && (
                particularReportTransactionCycleResponseLatest[i].status === 'Pending for Approval Employee- (step 2)'||
                particularReportTransactionCycleResponseLatest[i].status === 'Rejected' || particularReportTransactionCycleResponseLatest[i].status === Request_Stipend_Status.REVIEWRESUBMITTED
                )){
              empTitle = 'Employee';
            }
            else if (stipendMasterData.principalId === particularReportTransactionCycleResponseLatest[i].to_Employee_Id && (
                particularReportTransactionCycleResponseLatest[i].status === 'Pending for Prior Approval Principal- (step 3)' ||
                particularReportTransactionCycleResponseLatest[i].status === 'Pending for Final Approval Principal- (step 7)' ||
                particularReportTransactionCycleResponseLatest[i].status === 'Rejected' || particularReportTransactionCycleResponseLatest[i].status === Request_Stipend_Status.REVIEWRESUBMITTED ))
                {
              empTitle = 'Principal';
            }
            else if (stipendMasterData.hrTechI === particularReportTransactionCycleResponseLatest[i].to_Employee_Id && (
                particularReportTransactionCycleResponseLatest[i].status === "Pending for Completion HR Technician- (step 8)" ||
                particularReportTransactionCycleResponseLatest[i].status === 'Pending for Assignment Completion HR Technician- (step 6)' ||
                particularReportTransactionCycleResponseLatest[i].status === 'Pending for Prior Approval HR technician- (step 4)'||
                particularReportTransactionCycleResponseLatest[i].status === "Completed-(step 9)" ||
                particularReportTransactionCycleResponseLatest[i].status === 'Rejected' || particularReportTransactionCycleResponseLatest[i].status === Request_Stipend_Status.REVIEWRESUBMITTED ) ){
              empTitle = 'HR technician';
            }
            else if (stipendMasterData.executiveManagerId === particularReportTransactionCycleResponseLatest[i].to_Employee_Id && (
                particularReportTransactionCycleResponseLatest[i].status === 'Pending for Approval Excecutive Management- (step 5)' ||
                particularReportTransactionCycleResponseLatest[i].status === 'Rejected' || particularReportTransactionCycleResponseLatest[i].status === Request_Stipend_Status.REVIEWRESUBMITTED ) ){
              empTitle = 'Excecutive Management';
            }
            else if (particularReportTransactionCycleResponseLatest[i].status ==='Pending.- (step 1)'){
              empTitle = 'Initiator' 
          }else if (particularReportTransactionCycleResponseLatest[i].status === Request_Stipend_Status.REVIEWRESUBMITTED && stipendMasterData.createdBy === particularReportTransactionCycleResponseLatest[i].to_Employee_Id ) {
                    empTitle = 'Initiator'
                }
            else{
                empTitle = 'Employee';
            }
            
			
			
			//if user is updated get designation by Status
				if(empTitle === 'Employee'){
					
					if(particularReportTransactionCycleResponseLatest[i].status === 'Pending for Prior Approval Principal- (step 3)' ||
                particularReportTransactionCycleResponseLatest[i].status === 'Pending for Final Approval Principal- (step 7)'){
					empTitle = 'Principal';
				}else if (
                    particularReportTransactionCycleResponseLatest[i].status === "Pending for Completion HR Technician- (step 8)" ||
                    particularReportTransactionCycleResponseLatest[i].status === 'Pending for Assignment Completion HR Technician- (step 6)' ||
                    particularReportTransactionCycleResponseLatest[i].status === 'Pending for Prior Approval HR technician- (step 4)' ||
                    particularReportTransactionCycleResponseLatest[i].status === "Completed-(step 9)" 
                     ) {
                    empTitle = 'HR technician';
                }
                else if (
                    particularReportTransactionCycleResponseLatest[i].status === 'Pending for Approval Excecutive Management- (step 5)' 
                      ) {
                    empTitle = 'Excecutive Management';
                }

				if (
                    empTitle === 'Employee' && particularReportTransactionCycleResponseLatest[i].to_Employee_Id !== stipendMasterData.employeeId && 
                     particularReportTransactionCycleResponseLatest[i].to_Employee_Id === stipendMasterData.updatedBy ) {
                    empTitle= 'Super Admin';
                }
               
					///getDesignationByStatus(particularReportTransactionCycleResponseLatest[i])
				}
			
			
			
			
			

        let obj = {
          empName: fullName,
          empTitle:empTitle,
          empCode: userCodeEmp,
          status: particularReportTransactionCycleResponseLatest[i].isApproved ? "Approved" : particularReportTransactionCycleResponseLatest[i].status,
          approvedDate: dateTime
        }

        if (i == 0) {
          let initiatorUsers;

          try {
            //get initiator's data using its id
            initiatorUsers = await cognito.adminGetUser({
              UserPoolId: awsmobile.aws_user_pools_id,
              Username: particularReportTransactionCycleResponseLatest[i].from_Employee_Id,
            }).promise();
          } catch (e) {
            //console.log(e)
          }


          let userFirstName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:firstName") : ''
          let userLastName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:lastName") : ''
          let userCodeEmp1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:userCode") : ''
          let initiatorFullName = userFirstName1 + " " + userLastName1;

          let obj = {
            empName: initiatorFullName,
            empTitle: 'Initiator',
            empCode: userCodeEmp1,
            status: 'Submitted',
            approvedDate: (particularReportTransactionCycleResponseLatest[i].submittedDate) ? handleDateSelect(particularReportTransactionCycleResponseLatest[i].submittedDate) : handleDateSelect(currentDateTime)

          }
          setSubmittedBy(obj);
          approvalFinalData.push(obj);
          // approvalFinalData.unshift(obj);
        }

        //form history remark 
        if (particularReportTransactionCycleResponseLatest[i].status === Request_Stipend_Status.REJECT) {

          let obj = {
            empName: fullName, //empName,
            empTitle:empTitle,
            remarkType: Request_Stipend_Status.REJECT,
            empRemark: particularReportTransactionCycleResponseLatest[i].remark,
            approvedDate: dateTime
          };

          formHistoryFinalData.push(obj);
        }

        approvalFinalData.push(obj);
        setApprovalFinalData(approvalFinalData)
        //---End Approval Status-------

      }
    }
  }

  const getStipendFormDetails = async (reportId) => {

    const original = await DataStore.query(StipendMaster, reportId);

    let selectedConfirmationType = [];

    if (original.isMiddleStipend === true) {
      selectedConfirmationType.push({ name: 'Middle School Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isMiddleStipend' });
    }
    if (original.isElementaryStipend === true) {
      selectedConfirmationType.push({ name: 'Elementary Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isElementaryStipend' });
    }
    if (original.isHighStipend === true) {
      selectedConfirmationType.push({ name: 'High School Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isHighStipend' });
    }
    if (original.isDepartmentStipend === true) {
      selectedConfirmationType.push({ name: 'Department Chair Stipend(01.0-00000.0-11303-10000-1170-0005616)(01.0-65000.0-57606-11100-1170-0000600-SPED)', key: 'isDepartmentStipend' });
    }
    if (original.isHeadStipend === true) {
      selectedConfirmationType.push({ name: 'Head Counselor Stipend(01.0-00000.0-00000-31101-1272-0004682)', key: 'isHeadStipend' });
    }
    setSelectedConfirmation(selectedConfirmationType)

    let assignments = await DataStore.query(StipendAssignments, (c) => c.stipendMasterId.eq(original.id));

    var myArray = [];
    if (assignments.length > 0) {
      for (let i = 0; i < assignments.length; i++) {
        myArray.push({ "name": assignments[i].name, "amount": assignments[i].amount, "isSplit": assignments[i].isSplit, "splitText": assignments[i].splitText, "isDeptChair": assignments[i].isDeptChair, "noOfEmployee": assignments[i].noOfEmployee, "isExtraCurricular": assignments[i].isExtraCurricular })
      }
      setAssignmentArray(myArray)
    }

    const employeeCodeResponse = await DataStore.query(Employee, (c) => c.id.eq(original.employeeId));

    setEmployeeCode({ name: employeeCodeResponse[0].employee_name + " (" + employeeCodeResponse[0].employee_code + ")", code: employeeCodeResponse[0].id });

    const employee = await DataStore.query(Employee, original.employeeId);
    const school = await DataStore.query(Schools, original.schoolId);
    const schoolYear = await DataStore.query(YearMaster, original.schoolYearId);
    const semister = await DataStore.query(SemisterMaster, original.semisterId);

    if (employee)
      setEmployeId({ "name": employee.employee_name + " (" + employee.employee_code + ")", "code": employee.id })
    if (school)
      setLocation({ "name": school.name, "code": school.id })
    if (schoolYear)
      setSchoolYear({ "name": schoolYear.name, "code": schoolYear.id })
    if (semister)
      setSemister({ "name": semister.name, "code": semister.id })

    setStatus(original.statusStipend);
  }


  const [filterRequestedReports, setilterRequestedReports] = useState({
    semesterTitle: { value: null, matchMode: FilterMatchMode.CONTAINS },
    title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    school: { value: null, matchMode: FilterMatchMode.CONTAINS },
    schoolYear: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    semister: { value: null, matchMode: FilterMatchMode.EQUALS },
    remark: { value: null, matchMode: FilterMatchMode.CONTAINS },
    submittedOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Year: { value: null, matchMode: FilterMatchMode.CONTAINS },
    employee: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Assignee: { value: null, matchMode: FilterMatchMode.CONTAINS }
  });


  //Get Weekly Absence Report-Classified List
  const BindList = async () => {
    var schoolList = await DataStore.query(Schools);
    setSchoolList(schoolList);
    var employeeList = await DataStore.query(Employee, Predicates.ALL, {
      sort: s => s.employee_name(SortDirection.ASCENDING)
    });
    var employeeCodeListArray = []; employeeCodeListArray = ConvertResponseForEmployee(employeeList); setEmployeeCodeList(employeeCodeListArray);

    var schoolYears = await DataStore.query(YearMaster, Predicates.ALL);
    var schoolYearArray = []; schoolYearArray = ConvertResponseForSelect(schoolYears); setSchoolYearArray(schoolYearArray);

    var semisters = await DataStore.query(SemisterMaster, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    var semisterArray = []; semisterArray = ConvertResponseForSelect(semisters); setSemisterArray(semisterArray);

    var departments = await DataStore.query(DepartmentTypeMaster, Predicates.ALL);
    var departmentArray = []; departmentArray = ConvertResponseForSelect(departments); setDepartmentArray(departmentArray);

    var schoolListResponse = await DataStore.query(Schools, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    var schoolArray = []; schoolArray = ConvertResponseForSelect(schoolListResponse); setLocationList(schoolArray);

const listStipendMasterData = await graphQLGetAllData("listStipendMasters");
    //*load Stipend Request 
    loadStipependPayrollRequest(listStipendMasterData);
  }

  //initiate new report
  const initiateNewReport = async () => {
    //fetch employee table data
    setConfirmVisible2(false);
    SetBasicInfoPopUp(true);
    SetPreviewAndEdit(false);
    setIsUpdate(false);
    setBtnDisabled(false);

    try {
      setHRManager();
      setStipendMasterId('');
      setApproverEdit(false);
      // setSelectedHRTechnician('')
      setSelectedExecutiveManager('')
      setSelectedPrincipal('')
      setFormTitle('')
      setEmployeeId([])
      setEmployeeCodeOnly([])
      setLocation('')
      setSchoolYearId('')
      setSemisterId('')
      // setEmail('')
      setSelfAssign(false)
      setDepartmentId('')
      setDepartmentPeopleCount('')
      setAssignmentArray([{
        "name": "", "amount": "", "isSplit": false, "splitText": "", "isDeptChair": false, "noOfEmployee": "", "isExtraCurricular": false
      }]);
      setSelectedConfirmation([])
      setShowNextPopUp(true);
      loadNewReportUserData();

    } catch (error) {
      // console.log('Error retrieving posts', error);
    }
  }

  const loadNewReportUserData = async () => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params =
    {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };
    cognito.listUsers(params, (err, data) => {
      if (err) {
        // console.log(err);
      } else {
        // console.log(data)
        var newRes = []
        let userRole = '', userName = '', userEmail = '', userCode = '', sub, firstName = '', lastName = '';
        (data.Users).forEach((user, i) => {
          userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
          userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
          sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
          userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
          userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
          firstName = user.Attributes.find(attr => attr.Name === "custom:firstName")?.Value;
          lastName = user.Attributes.find(attr => attr.Name === "custom:lastName")?.Value;

          let obj = {
            "userId": sub,
            "name": userName,
            "email": userEmail,
            "usercode": userCode,
            "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
          }
          newRes.push(obj);
        }
        );

        //get only those users are without admin
        let usersWithoutAdminAndLoggedUser = [];
        const loggedUserId = reactLocalStorage.get('loggedUserId');

        newRes.map((currentItem) => {
          if (currentItem.role !== 'Admin'
            && currentItem.userId !== loggedUserId) {
            usersWithoutAdminAndLoggedUser.push(currentItem);
          }
        })

        //set employee list
        let finalEmployeeList = [{ name: "No Approval Needed", code: 'no_approval_needed' }];

        usersWithoutAdminAndLoggedUser.map((currentItem) => {
          let obj = { name: currentItem.name, code: currentItem.userId };
          finalEmployeeList.push(obj);
        })

        setPrincipleDepartmentHeadList(finalEmployeeList);
        setHRList(finalEmployeeList);
        setExecutiveList(finalEmployeeList);

      }
    });
  }


  //*loadAbsenceReport
  const loadStipependPayrollRequest = async (listStipendMaster) => {
    const stipendMasterRequestResponse = await DataStore.query(StipendMaster, Predicates.ALL, {
      sort: s => s.createdAt(SortDirection.DESCENDING)
    }
    );

    let finalArray = [];
	var index=0;
	outerLoop:
    for (let i = 0; i < stipendMasterRequestResponse.length; i++) {

      const substituteCertificateRequestTransactionCycleResponse = await DataStore.query(StipendTransactionCycle, (c) => c.and(c => [
        c.report_Id.eq(stipendMasterRequestResponse[i].id),
        c.to_Employee_Id.eq(loggedUserId),
        c.status.ne(Request_Stipend_Status.PENDING)
      ]), { sort: s => s.submittedDate(SortDirection.DESCENDING) }
      );

      let semisterName = '';

      if (stipendMasterRequestResponse[i].semisterId) {
        const semister = await DataStore.query(SemisterMaster, stipendMasterRequestResponse[i].semisterId);
        semisterName = semister ? semister.name : '';
      }

      const sortedRecords = substituteCertificateRequestTransactionCycleResponse.sort((a, b) => new Date(b.date) - new Date(a.date));

      if (sortedRecords.length > 0) {
		  
		   
		
        // for (let k = 0; k < sortedRecords.length; k++) {

        let statusTable = stipendMasterRequestResponse[i].statusStipend === "" ? "-" : stipendMasterRequestResponse[i].statusStipend;

        if (stipendMasterRequestResponse[i].statusStipend === Request_Stipend_Status.REJECT) {
          statusTable = Request_Stipend_Status.REJECT
        }

        let employeeDetails = await DataStore.query(Employee, stipendMasterRequestResponse[i].employeeId);
        let schoolDetails = await DataStore.query(Schools, stipendMasterRequestResponse[i].schoolId);
        let semisterDetails = await DataStore.query(SemisterMaster, stipendMasterRequestResponse[i].semisterId);
        let schoolYearDetails = await DataStore.query(YearMaster, stipendMasterRequestResponse[i].schoolYearId);

        let assignments = await DataStore.query(StipendAssignments, (c) => c.stipendMasterId.eq(stipendMasterRequestResponse[i].id));

        var myArray = [];
        var assignmentArr = '';

        let stipendType = '';
        if (stipendMasterRequestResponse[i].isMiddleStipend === true) {
          stipendType = 'Middle School Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)';
        } else if (stipendMasterRequestResponse[i].isElementaryStipend === true) {
          stipendType = 'Elementary Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)';
        } else if (stipendMasterRequestResponse[i].isHighStipend === true) {
          stipendType = 'High School Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)';
        } else if (stipendMasterRequestResponse[i].isDepartmentStipend === true) {
          stipendType = 'Department Chair Stipend(01.0-00000.0-11303-10000-1170-0005616)(01.0-65000.0-57606-11100-1170-0000600-SPED)';
        } else if (stipendMasterRequestResponse[i].isHeadStipend === true) {
          stipendType = 'Head Counselor Stipend(01.0-00000.0-00000-31101-1272-0004682)';
        }


        if (assignments.length > 0) {
          for (let k = 0; k < assignments.length; k++) {
            myArray.push({ 'Assignment Name': assignments[k].name, "Amount": assignments[k].amount })
          }
        }

        const particularReportTransactionCycleResponseLatest = await DataStore.query(StipendTransactionCycle, c =>
          c.report_Id.eq(stipendMasterRequestResponse[i].id), { sort: s => s.createdAt(SortDirection.ASCENDING) }
      );


      console.log("particularReportTransactionCycleResponseLatest",particularReportTransactionCycleResponseLatest);

      let adminUsers;
      let Assignee = "";
      if (particularReportTransactionCycleResponseLatest.length) {
          const cognito = new AWS.CognitoIdentityServiceProvider();

          try {
              adminUsers = await cognito.adminGetUser({
                  UserPoolId: awsmobile.aws_user_pools_id,
                  Username: (particularReportTransactionCycleResponseLatest[particularReportTransactionCycleResponseLatest.length - 1].status == 'Rejected' ? loggedUserId : particularReportTransactionCycleResponseLatest[particularReportTransactionCycleResponseLatest.length - 1].to_Employee_Id)
              }).promise();
          } catch (e) {
              //console.log(e)
          }

          let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
          let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
          Assignee = userFirstName + " " + userLastName

      }

      let NewAssignee =  particularReportTransactionCycleResponseLatest[particularReportTransactionCycleResponseLatest.length - 1].status == "Completed-(step 9)" ? "-" : Assignee;

let archiveDesignation = getArchiveDesignationApprover(stipendMasterRequestResponse[i],statusTable)
                    
					const currentItem1 = listStipendMaster.find(item=>item.id ===stipendMasterRequestResponse[i].id )
				
                    
					
                    if (currentItem1 && currentItem1?.isArchivedUsers) {
						
						if (JSON.stringify(currentItem1?.isArchivedUsers) === '[]' || JSON.stringify(currentItem1?.isArchivedUsers) === '{}') {
					  console.log('The attribute has only {}.');
					} else {
						
						console.log(currentItem1?.isArchivedUsers,"archieveData1")
                        const archieveData = JSON.parse(currentItem1?.isArchivedUsers);
//console.log(archieveData,"archieveData1")
                        let isArchive = CheckArchive(archieveData, archiveDesignation, loggedUserId);
                        if (isArchive) {
                            continue outerLoop;
                        }
                    }
				}




index = index + 1

        let data = {
          "id": sortedRecords[0].id,
          "stipendType": stipendType,
		  "reportId":stipendMasterRequestResponse[i].id,
		  "archiveDesignation": archiveDesignation,
          "employee": employeeDetails ? employeeDetails.employee_name : '',
          "employeeCode": employeeDetails ? employeeDetails.employee_code : '',
          "schoolYear": schoolYearDetails ? schoolYearDetails.name : '',
          "school": schoolDetails ? schoolDetails.name : '',
          "semister": semisterDetails ? semisterDetails.name : '',
          "principalId": stipendMasterRequestResponse[i].principalId ? stipendMasterRequestResponse[i].principalId : '',
          "hrTechI": stipendMasterRequestResponse[i].hrTechI ? stipendMasterRequestResponse[i].hrTechI : '',
          "executiveManagerId": stipendMasterRequestResponse[i].executiveManagerId ? stipendMasterRequestResponse[i].executiveManagerId : '',
          "assignmentArray": myArray,
          "semesterTitle": semisterName,
          "title": stipendMasterRequestResponse[i].title ? stipendMasterRequestResponse[i].title : '-',
          "submittedOn": sortedRecords[0].submittedDate ? moment(sortedRecords[0].submittedDate).format("MM/DD/YYYY") : moment(currentDateTime).toISOString(),
          "createdAt": stipendMasterRequestResponse[i].createdAt ? moment(stipendMasterRequestResponse[i].createdAt).format("MM/DD/YYYY") : moment(currentDateTime).toISOString(),
          "status": statusTable,
          "statusCycle": sortedRecords[0].status,
          "isSoftDelete": stipendMasterRequestResponse[i].isSoftDelete ? stipendMasterRequestResponse[i].isSoftDelete : false ,
          "remark": stipendMasterRequestResponse[i].remark ? stipendMasterRequestResponse[i].remark : '-',
          "isApproved": sortedRecords[0].isApproved,
          "rejectedBy": stipendMasterRequestResponse[i].rejectedBy ? stipendMasterRequestResponse[i].rejectedBy : 'false',
          "CC": sortedRecords[0].ccEmail,
          "sLNo": index,
          "Assignee" : NewAssignee
        }
        finalArray.push(data)
        // }

        let sortedData = [...finalArray].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
		if (selectedRows.length) {
            sortedData = sortedData.filter(item => !selectedRows.includes(item.id));
            setSelectedRows([]);
            // continue outerLoop;
        }
        setStipendPayrollReportListInitiator(sortedData.filter(i => i.isSoftDelete != true))
        setIsLoader(false)
      }
    }
  }

  async function approversList(e) {
    try {
      var employeeResponses = await DataStore.query(Employee, Predicates.ALL, {
        sort: s => s.employee_name(SortDirection.ASCENDING)
      });
      // console.log('original->employeeResponses', employeeResponses)

      if (employeeResponses !== null) {
        let employeeData = employeeResponses;

        let employee = [];
        employeeData.map((item) => {
          let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
          let obj = {
            name: name,
            code: item.user_Id
          }
          employee.push(obj);

        })
        if (e) {
          let employeeSearchData = [];
          employeeSearchData = employee.filter(item => item.employee_code === e.target.value);
          employeeSearchData = employee.filter(item => item.employee_name === e.target.value);
          setApproverList(employee)
        } else {
          setApproverList(employee)
        }

        console.log('original->approverRoleList', employee)

      }
    }
    catch (error) {
      console.log(error)
    }
  }

  async function userList(e) {
    try {
      var employeeResponses = await DataStore.query(Employee, Predicates.ALL, {
        sort: s => s.employee_name(SortDirection.ASCENDING)
      });

      // console.log('original->employeeResponses', employeeResponses)

      if (employeeResponses !== null) {
        let employeeData = employeeResponses;

        let employee = [];
        employeeData.map((item) => {
          let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
          let obj = {
            name: name,
            code: item.id
          }
          employee.push(obj);

        })
        if (e) {
          let employeeSearchData = [];
          employeeSearchData = employee.filter(item => item.employee_code === e.target.value);
          employeeSearchData = employee.filter(item => item.employee_name === e.target.value);
          setAllApproverList(employee)
        } else {
          setAllApproverList(employee)
        }

        console.log('original->approverRoleList', employee)

      }
    }
    catch (error) {
      console.log(error)
    }
  }

  const loadUsers = () => {
    //------------------------------- load users-------------
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params =
    {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };
    cognito.listUsers(params, (err, data) => {
      if (err) {
        // console.log(err);
      } else {
        // console.log(data)
        SetUsersList(data.Users);
        var newRes = []
        let userRole = '', userName = '', userEmail = '', userCode = '', sub;
        (data.Users).forEach((user, i) => {
          userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
          userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
          sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
          userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
          userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

          let obj = {
            "userId": sub,
            "name": userName,
            "email": userEmail,
            "usercode": userCode,
            "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
          }
          newRes.push(obj);
        }
        );

        //get only those users are without admin
        let usersWithoutAdminAndLoggedUser = [];
        const loggedUserId = reactLocalStorage.get('loggedUserId');

        newRes.map((currentItem) => {
          if (currentItem.role !== 'Admin'
            && currentItem.userId !== loggedUserId) {
            usersWithoutAdminAndLoggedUser.push(currentItem);
          }
        })

        fetchAndSetLoggedInUserData(loggedInUserData).then((data) => {
          setLoggedInUserData(data);
        });
        //set employee list
        let finalEmployeeList = [{ name: "No Approval Needed", code: 'no_approval_needed' }];

        usersWithoutAdminAndLoggedUser.map((currentItem) => {
          let obj = { name: currentItem.name, code: currentItem.userId };
          finalEmployeeList.push(obj);
        })


        var approverArrayReject = []; approverArrayReject = ConvertResponseOfNameCodeForSelect(finalEmployeeList); setApproverListForReject(approverArrayReject);
      }
    });
  }

  const fetchAndSetLoggedInUserData = async (userId) => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 1
    };

    params['Filter'] = "sub ^=\"" + userId + "\""

    try {
      const data = await cognito.listUsers(params).promise();
      if (data.Users.length > 0) {
        const user = data.Users[0];

        const userRoleAttribute = user.Attributes.find(attr => attr.Name === 'custom:role');
        const userNameAttribute = user.Attributes.find(attr => attr.Name === 'name');
        const sub = user.Attributes.find(attr => attr.Name === 'sub');
        const userEmailAttribute = user.Attributes.find(attr => attr.Name === 'email');
        const userCodeAttribute = user.Attributes.find(attr => attr.Name === 'custom:userCode');
        const signatureAttribute = user.Attributes.find(attr => attr.Name === 'custom:userSignature');

        let role;
        switch (userRoleAttribute?.Value) {
          case USER_TYPES.SUPERADMIN:
            role = USER_TYPES_NAMES.SA;
            break;
          case USER_TYPES.ADMIN:
            role = USER_TYPES_NAMES.A;
            break;
          case USER_TYPES.APPROVER:
            role = USER_TYPES_NAMES.AP;
            break;
          case USER_TYPES.PAYROLL:
            role = USER_TYPES_NAMES.P;
            break;
          default:
            role = USER_TYPES_NAMES.I;
        }

        return {
          userId: sub?.Value,
          name: userNameAttribute?.Value,
          email: userEmailAttribute?.Value,
          usercode: userCodeAttribute?.Value,
          signature: signatureAttribute?.Value,
          role: role
        };
      }
    } catch (error) {
      toast.error(error.message);
      return null;
    }
    return null;
  }

  //onclick remove inquiry document
  const onClickRemoveAssignment = (index) => {
    let data = [...assignmentArray];
    if (data.length > 1) {
      data.splice(index, 1)
      setAssignmentArray(data)
    }
  }

  const onClickAddAssignment = () => {
    let data = { "name": "", "amount": "", "isSplit": false, "splitText": "", "isDeptChair": false, "noOfEmployee": "", "isExtraCurricular": false }
    let newData = [...assignmentArray, data];
    setAssignmentArray(newData)
  }


  const onChangeAssignment = (index, value, type = 'N') => {
    let data = [...assignmentArray]
    if (type === 'N') {
      data[index]["name"] = value;
    }
    else if (type === 'A') {
      const re = /^[0-9\b]+$/;
      // if value is not blank, then test the regex

      const sanitizedValue = value.replace(/[^$0-9]/g, '');
      data[index]["amount"] = sanitizedValue;

    }
    else if (type === 'S') {
      if (value.checked)
        data[index]["isSplit"] = true;
      else
        data[index]["isSplit"] = false;
    }
    else if (type === 'DC') {
      if (value.checked)
        data[index]["isDeptChair"] = true;
      else
        data[index]["isDeptChair"] = false;
    }
    else if (type === 'E') {
      if (value.checked)
        data[index]["isExtraCurricular"] = true;
      else
        data[index]["isExtraCurricular"] = false;
    } else if (type === 'ST') {
      data[index]["splitText"] = value;
    } else if (type === 'DCT') {
      const sanitizedValue = value.replace(/[^0-9]/g, '');
      data[index]["noOfEmployee"] = sanitizedValue;
    }

    setAssignmentArray(data)
  }

  const footerContentForReqReject = () => (
    <div className='text-center'>

      {
        (sendMsg) ?
          <button className='bg-[#113699] border border-[##113699] text-white px-8
           py-2 rounded' onClick={() => {
              BindList();
              setRejectVisible(false);
              setVisibleRequestedReportEdit(false);
              setSendMsg(false);
            }}>Ok</button> :

          <>
            <button className='bg-[#113699] border border-[##113699] text-white px-8
           py-2 rounded' onClick={() => {

                if (!fallBackApproverLevel) {
                  toast.error("Please Select An Approval Level");
                  return;
                }
                if (!fallBackApproverId) {
                  toast.error("Please Select An Approver");
                  return;
                }

                if (rejectMsgValue === "") {
                  toast.error("Please Enter the Reason For Rejection");
                  return;
                }
                approveSelectedReport(transactionCycleReportId, Request_Stipend_Status.REJECT);
                setRejectVisible(false);
                setVisibleRequestedReportEdit(false);
                setSendMsg(false);
              }}>Send</button>

            <button className='bg-[#113699] border border-[##113699] text-white px-8
           py-2 rounded' onClick={() => {
                setRejectVisible(false);
              }}>Cancel</button>
          </>
      }

    </div>
  );

  const exportFilteredApproverDataToCSV = async (fileName) => {

    const cognito = new AWS.CognitoIdentityServiceProvider();
    for (let i = 0; i < stipendPayrollReportListInitiator.length; i++) {

      let principal;

      if (stipendPayrollReportListInitiator[i].principalId) {
        try {
          principal = await cognito
            .adminGetUser({
              UserPoolId: awsmobile.aws_user_pools_id,
              Username: stipendPayrollReportListInitiator[i].principalId
            })
            .promise();
        } catch (e) {
          console.log(e)
        }
      }
      let principalName = principal ? principal.UserAttributes.find(attr => attr.Name === "name") : "";

      let executiveManager;
      if (stipendPayrollReportListInitiator[i].executiveManagerId) {
        try {
          executiveManager = await cognito
            .adminGetUser({
              UserPoolId: awsmobile.aws_user_pools_id,
              Username: stipendPayrollReportListInitiator[i].executiveManagerId
            })
            .promise();
        } catch (e) {
          console.log(e)
        }
      }
      let executiveManagerName = executiveManager ? executiveManager.UserAttributes.find(attr => attr.Name === "name") : "";

      let hrTech;
      if (stipendPayrollReportListInitiator[i].hrTechI) {
        try {
          hrTech = await cognito
            .adminGetUser({
              UserPoolId: awsmobile.aws_user_pools_id,
              Username: stipendPayrollReportListInitiator[i].hrTechI
            })
            .promise();
        } catch (e) {
          console.log(e)
        }
      }

      let hrTechName = hrTech ? hrTech.UserAttributes.find(attr => attr.Name === "name") : "";

      stipendPayrollReportListInitiator[i] = {
        ...stipendPayrollReportListInitiator[i],
        principalData: principalName ? principalName.Value : '',
        executiveManager: executiveManagerName ? executiveManagerName.Value : '',
        hrTech: hrTechName ? hrTechName.Value : '',
        sLNo: i ? i : 0,
      }

    }

    const dataToExport = stipendPayrollReportListInitiator.map(({ sLNo, title, stipendType, remark, employee, employeeCode, school, schoolYear, semister, principalData, executiveManager, hrTech, CC, status }) => ({
      "Sl. No": sLNo + 1, "Form Title": title, "Employee Name": employee, "Employee Id": employeeCode, "School Name": school, "School Year": schoolYear, "Semester": semister, "Stipend Type": stipendType, "Remarks": remark, "Principal ": principalData, "Executive Manager": executiveManager, "HR Technician": hrTech, "CC": CC, "Status": status,
    }));

    const csvData = convertArrayOfObjectsToCSV(dataToExport);
    downloadCSV(csvData, fileName);
  };


  //CSV Download
  const convertArrayOfObjectsToCSV = (data) => {
    const csvRows = [];
    const headers = Object.keys(data[0]);

    csvRows.push(headers.join(','));

    for (const row of data) {
      const values = headers.map((header) => row[header]);
      csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
  };

  const downloadCSV = (data, filename) => {
    const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  const handleAddSignature = async () => {
    const cognito = new AWS.CognitoIdentityServiceProvider();

    var params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };

    params['Filter'] = "sub ^=\"" + loggedUserId + "\"";
    await cognito.listUsers(params, (err, data) => {
      if (data) {
        let signature = data.Users[0].Attributes.find(attr => attr.Name === "custom:userSignature")?.Value;
        if (signature != null && signature.trim() !== '') {
          setSignaturePath(signature);
          loadSignatureFile(signature)
        } else {
          setSignatureDialog(true);
        }
      }
    });
  }

  const loadSignatureFile = async (filePath) => {
    let file = null;
    await Storage.get(filePath)
      .then(result => {
        console.log(result);
        file = result;
      });

    if (file) {
      setSignatureFileAwsPath(file);
    }
  }

  useEffect(() => {
    let formTitle = '';

    if (employeeId) {
      formTitle = formTitle + (employeeId.name ? employeeId?.name : '(EmpId)');
    }
    if (schoolYearId.name !== 'undefined') {
      formTitle = formTitle + '- ' + (schoolYearId ? schoolYearId?.name : '(School Year)');
    }
    if (semisterId.name !== 'undefined') {
      formTitle = formTitle + '- ' + (semisterId ? semisterId?.name : '(Semester)');
    }

    setFormTitle(formTitle)
  }, [schoolYearId, semisterId, employeeId]);

  useEffect(() => {
    // onLoad();
    loadUsers();
    userList();
    approversList();
    BindList();
  }, []);

  useEffect(() => {
    loadUsers();
  }, [users]);

  useEffect(() => {
    // loadUsers();
    if (addSignature) {
      handleAddSignature();
    }

    console.log(signatureFileAwsPath !== null && !addSignature, signatureFileAwsPath, addSignature);
  }, [addSignature])


  return isAuthenticated ? (
    <>
      <ReactFullscreen>
        {({ onToggle }) => (
          <Layout pageTitle="Report" activeMenu="Initiator" appId='STIPENDS_FORM' IsArchive={true}
                        reDirectUrlforArchive={"/stipend_forms/ReportTemplate/ArchiveReport"}>
            <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
              <div className="flex justify-end visible lg:hidden">
                <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

              </div>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
                <div className="relative z-10 col-span-12 lg:col-span-12" data-aos="fade-down" data-aos-duration="800">
                  <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                    <div className="flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                      <p className="text-[22px] xl:text-[0.938vw]  text-[#101828] font-medium">Stipend Forms</p>
                      <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                        {
                          activeIndex === 0 && loggedStipendPayroll === '1' ?
                            <>
                              <Link to="#" onClick={() => { exportFilteredApproverDataToCSV("StipendPayrollReport.csv") }} className=" " > <i className="pi pi-download "></i></Link>
                            </> : null
                        }

                        <Link to="" onClick={onToggle}> <i className="gusd-expand"></i></Link>
                      </div>
                    </div>

                    {
                      (loggedStipendPayroll === '1') ?
                        <TabView activeIndex={activeIndex} onTabChange={(e) => {
                          setActiveIndex(e.index)
                        }}>
                          <TabPanel header="Requested Reports">
                            <div className={stipendPayrollReportListInitiator.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow"}>
                              <DataTable
                                className="custpaginator custIcons custmBtnTable custTable"
                                scrollable
                                filters={filterRequestedReports}
                                filterDisplay="row"
                                value={stipendPayrollReportListInitiator}
                                paginator rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}
                                emptyMessage="No records found."
								loading={isLoader}
                              >
                                <Column header="SL#" body={CounterAction} style={{ minWidth: '3rem' }}></Column>
                                
								 <Column
									style={{ minWidth: "3rem" }}
									header={<CheckboxHeader
										queries={queries.getStipendMaster}
										tableName={"getStipendMaster"}
										mutations={mutations.updateStipendMaster}
										data={stipendPayrollReportListInitiator}
										selectedRows={selectedRows} setSelectedRows={setSelectedRows}
										getMasterData={() => BindList()} setReportLoading={setIsLoader} loggedUserId={loggedUserId} stipendApprover="stipendApprover"
									/>}
									body={(rowData) => <CheckboxColumn data={rowData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />}
								/>
								
								
								
								
								<Column header="Title" field="title" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }}></Column>
                                <Column field="employee" filter filterPlaceholder='Search' header="Employee Name" sortable style={{ minWidth: '10rem' }}></Column>
                                <Column field="school" filterPlaceholder='Search' filter header="School" sortable style={{ minWidth: '5rem' }}></Column>
                                <Column field="schoolYear" filterPlaceholder='Search' filter header="Year" sortable style={{ minWidth: '5rem' }}></Column>
                                <Column field="semesterTitle" header="Semester" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }}></Column>
                                {/* <Column field="dates" filter filterPlaceholder="Search" header="Created Date" sortable></Column> */}
                                <Column field="submittedOn" header="Submitted On" sortable filter filterPlaceholder="Search" style={{ minWidth: '10rem' }}></Column>
                                <Column header="Status" field="status" filter filterElement={statusRowFilterTemplate} body={TaskStatusSLA} sortable style={{ minWidth: '8rem' }}></Column>
                                <Column field="Assignee" header="Assignee" filter align='center' filterPlaceholder="Search" sortable style={{ minWidth: '6rem' }}></Column>
                                <Column field="remark" header="Remarks" filter align='center' filterPlaceholder="Search" style={{ minWidth: '6rem' }}></Column>
                                <Column field="action" header="Action" frozen alignFrozen="right" align='center' body={approverReportAction} style={{ minWidth: '6rem' }}></Column>
                              </DataTable>
                            </div>
                          </TabPanel>
                        </TabView>
                        : <div className="text-[#113699] text-md md:text-[0.833vw] font-bold mt-3 text-center p-5">No access found. Please contact with Administrator...</div>
                    }


                    < Dialog className="relative reports-popup" visible={visibleRequestedReportView} position={position}
                      style={{ width: `${(fullApproverViewForView) ? '92.917vw' : '59.740vw'}` }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() =>
                        setFullApproverViewForView(false)
                      } draggable={false} resizable={false}>
                      <div className="grid grid-cols-2 lg:grid-cols-12">
                        <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">
                          <div className="p-5">
                            {
                              (!fullApproverViewForView) ?
                                <div onClick={() => setVisibleRequestedReportView(false)} className="py-3">
                                  <Image src={sideBarRight} alt="user" width="24" height="24" />
                                </div>
                                : <div onClick={() => setFullApproverViewForView(false)} className="py-3">
                                  <Image src={sideBarRight} alt="user" width="24" height="24" />
                                </div>
                            }

                            {
                              (!fullApproverViewForView) ?
                                <div>
                                  <div className='text-center'>
                                    <div><b>GLENDALE UNIFIED SCHOOL DISTRICT</b></div>
                                    <div className="text-[#344054] text-xs lg:text-[0.833vw] font-medium">Request For Approval - Stipend Form</div>
                                  </div>
                                </div> : null
                            }
                            {
                              (!fullApproverViewForView) ?
                                <div>
                                  {/* <div className="text-[#113699] text-md md:text-[0.833vw] font-bold mt-3">Substitute Request Classified</div> */}

                                  <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                    <div className="mb-1">
                                      <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Approval Status </label>
                                      <div className="py-3 emp-simple-tbl">
                                        <DataTable
                                          className="custpaginator custIcons custmBtnTable custTable"
                                          value={approvalCompleteData}
                                        >
                                          <Column field="empCode" header="Employee Id"></Column>
                                          <Column field="empName" header="Name"></Column>
                                          <Column field="status" body={approvalStatusBody} header="Status"></Column>
                                          <Column field="approvedDate" header="Time Stamp"></Column>

                                        </DataTable>
                                      </div>
                                    </div>
                                  </div>
                                </div> : null
                            }

                            <div className="rounded-[8px] p-3 mt-3"   >

                              {
                                (!fullApproverViewForView) ?
                                  <div className='flex justify-between'>
                                    <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Stipends Form...pdf</div>
                                    <button onClick={() => setFullApproverViewForView(true)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen</button>
                                  </div> :
                                  <div className='flex justify-between border border-1'>
                                    <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Stipends Form.pdf</div>
                                    <button onClick={() => setFullApproverViewForView(false)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen</button>
                                  </div>
                              }
                              {
                                (!fullApproverViewForView) ?
                                  <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] print:p-5 h-[30vw] overflow-auto bg-white' >
                                    {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                    <div id="my-html-template" >
                                      <StipendFormPdf
                                        data={{
                                          'schoolName': location.name,
                                          'schoolYear': schoolYear.name,
                                          'schoolSemister': semister.name,
                                          'employeeName': employeId.name,
                                          'departmentTypeName': departmentId.name,
                                          'departmentCount': departmentPeopleCount,
                                          'assignmentArray': assignmentArray,
                                          'previewAndEdit': previewAndEdit,
                                          'stipendTypes': confirmed,
                                          'approvalFinalData': approvalCompleteData,
                                          'selectedConfirmation': selectedConfirmation,
                                        }}
                                      />
                                    </div>
                                  </div>
                                  :
                                  <div className="grid grid-cols-1 " >
                                    {/* <img src={pdfImage} alt='myImg' /> */}
                                    <div className='bg-white py-5 px-5'>
                                      <StipendFormPdf ref={componentRef}
                                        data={{
                                          'schoolName': location.name,
                                          'schoolYear': schoolYear.name,
                                          'schoolSemister': semister.name,
                                          'employeeName': employeId.name,
                                          'departmentTypeName': departmentId.name,
                                          'departmentCount': departmentPeopleCount,
                                          'assignmentArray': assignmentArray,
                                          'previewAndEdit': previewAndEdit,
                                          'stipendTypes': confirmed,
                                          'approvalFinalData': approvalCompleteData,
                                          'selectedConfirmation': selectedConfirmation,
                                        }}
                                      />
                                    </div>

                                  </div>
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">

                          <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                            <div className="card custTable">

                              <Timeline value={approvalCompleteData}
                                opposite={(item) => <Tag
                                  severity={approveStatusOptions(item)} className="mr-2 relative top-[-5px]"
                                  value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                    <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                    <small className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</small>
                                    <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                    <div className="text-color-secondary text-[9px] ml-2">{item.approvedDate}</div>
                                  </div>} />

                            </div>
                          </div>
                        </div>


                      </div>
                    </Dialog>


                    {/* edit popup for requested report start */}
                    < Dialog className="relative reports-popup" visible={visibleApprovalRequestedReportEdit} position="right" style={{ width: `${(fullApproverEdit) ? '92.917vw' : '59.740vw'}` }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleApprovalRequestedReportEdit(false)} draggable={false} resizable={false} >
                      <div className="grid grid-cols-2 lg:grid-cols-12">
                        <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">
                          <div className="p-5">
                            {
                              (!fullApproverEdit) ?
                                <div onClick={() => setVisibleApprovalRequestedReportEdit(false)} className="py-3">
                                  <Image src={sideBarRight} alt="user" width="24" height="24" />
                                </div>
                                : <div onClick={() => setFullApproverEdit(false)} className="py-3">
                                  <Image src={sideBarRight} alt="user" width="24" height="24" />
                                </div>
                            }

                            {
                              (!fullApproverEdit) ?
                                <div>
                                  <div className='text-center'>
                                    <div><b>GLENDALE UNIFIED SCHOOL DISTRICT</b></div>
                                    <div className="text-[#344054] text-xs lg:text-[0.833vw] font-medium">Request For Approval - Stipend Form</div>
                                  </div>
                                </div> : null
                            }
                            {
                              (!fullApproverEdit) ?
                                <div>
                                  {/* <div className="text-[#113699] text-md md:text-[0.833vw] font-bold mt-3">Substitute Request Classified</div> */}

                                  <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                    <div className="mb-1">
                                      <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Approval Status </label>
                                      <div className="py-3 emp-simple-tbl">
                                        <DataTable
                                          className="custpaginator custIcons custmBtnTable custTable"
                                          value={approvalCompleteData}
                                        >
                                          <Column field="empCode" header="Employee Id"></Column>
                                          <Column field="empName" header="Name"></Column>
                                          <Column field="status" body={approvalStatusBody} header="Status"></Column>
                                          <Column field="approvedDate" header="Time Stamp"></Column>

                                        </DataTable>
                                      </div>
                                    </div>
                                  </div>
                                </div> : null
                            }

                            <div className="rounded-[8px] p-3 mt-3"   >

                              {
                                (!fullApproverEdit) ?
                                  <div>
                                    <div className='flex justify-between'>
                                      <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Stipends Form...pdf</div>
                                      <div className='col space-x-4'>
                                        <button onClick={() => setFullApproverEdit(true)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen</button>
                                        <button onClick={() => {
                                          onClickApproverEditData();
                                        }} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-edit mr-1 mt-2"></i>Edit Stipend Form</button>
                                      </div>
                                    </div>
                                    <div className='flex justify-end'>
                                      {/* {hideEditButton ? : null} */}

                                      {/* <button onClick={() => {
                                        onClickApproverEditData();
                                      }} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-edit mr-1 mt-2"></i>Edit Stipend Form</button> */}


                                    </div>
                                  </div>

                                  :
                                  <div className='flex justify-between border border-1'>
                                    <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Stipends Form.pdf</div>
                                    <button onClick={() => setFullApproverEdit(false)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen</button>
                                  </div>
                              }
                              {
                                (!fullApproverEdit) ?
                                  <>

                                    <div className="mt-[24px] xl:mt-[1.250vw] print:p-5 h-[30vw] overflow-auto bg-white">
                                      <StipendFormPdf
                                        data={{
                                          'schoolName': location.name,
                                          'schoolYear': schoolYear.name,
                                          'schoolSemister': semister.name,
                                          'employeeName': employeId.name,
                                          'departmentTypeName': departmentId.name,
                                          'departmentCount': departmentPeopleCount,
                                          'assignmentArray': assignmentArray,
                                          'previewAndEdit': previewAndEdit,
                                          'stipendTypes': confirmed,
                                          'approvalFinalData': approvalCompleteData,
                                          'selectedConfirmation': selectedConfirmation,
                                        }}
                                      />
                                    </div>
                                    <div className="mb-1 mt-2 pb-5 space-y-1">
                                      <div className="pl-2 pt-5 text-[#344054] font-medium text-[20px] flex">
                                        <InputSwitch checked={addSignature} onChange={(e) => setAddSignature(e.value)} />
                                        <label style={{ marginLeft: "2%" }}>Add Signature <span class="text-[red] pl-0.2">*</span></label>
                                      </div>

                                      {(addSignature && signatureFileAwsPath !== null) ?
                                        <div className="py-3 px-5 rounded-[8px] mt-3">
                                          <Card>
                                            <img className={"w-[20%] h-[15%]"}
                                              src={signatureFileAwsPath}
                                            />
                                          </Card>
                                        </div> : null}
                                    </div>
                                    {/* {
                                      status === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT ?
                                        <div className="mb-1 mt-2 pb-5 space-y-1">
                                          <div>
                                            <label className="text-[#344054] font-medium text-xs">CC Email:</label>
                                          </div>
                                          <div className="relative">
                                            <input
                                              type="text"
                                              onChange={e => setEmail(e.target.value)}
                                              value={email}
                                              placeholder="Type Email address"
                                              className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:py-[0.625vw] py-[10px] xl:pr-[0.625vw] pr-[10px] pl-8 placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                                            />
                                            <i className="mailicon absolute left-3 top-3"></i>
                                          </div>
                                        </div>
                                        : ''
                                    } */}

                                    {
                                      status === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN ? <>
                                        <div className="mb-10 px-5 py-3 grid grid-cols-2 gap-2 ">

                                          <Link to='#'
                                            onClick={() => {
                                              setVisibleApprovalRequestedReportEdit(false)
                                            }}
                                            className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                                          ><i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>

                                          <button onClick={() => {
                                            // if (isApproveButtonDisable === false) {
                                            approveSelectedReport(transactionCycleReportId, Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN)
                                            // }
                                          }}
                                            disabled={approveBtnDisabled ? true : false}
                                            className="text-center  bg-[#EFF8FF] flex items-center tableBtn bg-white text-[#039855] border border-[#D0D5DD] radius8"
                                          ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Acknowledge</button>
                                        </div>
                                      </> : <>
                                        <div className="mb-10 px-5 py-3 grid grid-cols-3 gap-2 ">

                                          <Link to='#' onClick={() => {
                                            setVisibleApprovalRequestedReportEdit(false)
                                          }} className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                                          ><i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>
                                          {
                                            isApproveButtonDisable === true ?
                                              < Link to='' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center text-[#D92D20]"
                                                onClick={() => {
                                                  setRejectVisible(true);
                                                }
                                                }
                                              ><i className="gusd-close mr-1" style={{ fontSize: '1rem' }}></i>Reject</Link>
                                              :

                                              < Link to='' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center text-[#D92D20]"
                                                //  onClick={() => saveGroupInfo()}
                                                onClick={() => {
                                                  handleRejectClick();
                                                  setRejectVisible(true);
                                                }
                                                }
                                              ><i className="gusd-close mr-1" style={{ fontSize: '1rem' }}></i>Reject</Link>

                                          }

                                          {
                                            <button onClick={() => {
                                              // if (isApproveButtonDisable === false) {
                                              approveSelectedReport(transactionCycleReportId, Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN)
                                              // }
                                            }}
                                              disabled={approveBtnDisabled ? true : false}
                                              className="text-center  bg-[#EFF8FF] flex items-center tableBtn bg-white text-[#039855] border border-[#D0D5DD] radius8"
                                            ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Approve</button>
                                          }
                                        </div>

                                      </>
                                    }
                                  </>
                                  :

                                  <div className="grid grid-cols-1 " >
                                    {/* <img src={pdfImage} alt='myImg' /> */}
                                    <div className='bg-white py-5 px-5'>
                                      <StipendFormPdf ref={componentRef}
                                        data={{
                                          'schoolName': location.name,
                                          'schoolYear': schoolYear.name,
                                          'schoolSemister': semister.name,
                                          'employeeName': employeId.name,
                                          'departmentTypeName': departmentId.name,
                                          'departmentCount': departmentPeopleCount,
                                          'assignmentArray': assignmentArray,
                                          'previewAndEdit': previewAndEdit,
                                          'stipendTypes': confirmed,
                                          'approvalFinalData': approvalCompleteData,
                                          'selectedConfirmation': selectedConfirmation,
                                        }}
                                      />
                                    </div>
                                    <div className="mb-1 mt-2 pb-5 space-y-1">
                                      <div className="pl-2 pt-5 text-[#344054] font-medium text-[20px] flex">
                                        <InputSwitch checked={addSignature} onChange={(e) => setAddSignature(e.value)} />
                                        <label style={{ marginLeft: "2%" }}>Add Signature <span class="text-[red] pl-0.2">*</span></label>
                                      </div>

                                      {(addSignature && signatureFileAwsPath !== null) ?
                                        <div className="py-3 px-5 rounded-[8px] mt-3">
                                          <Card>
                                            <img className={"w-[20%] h-[15%]"}
                                              src={signatureFileAwsPath}
                                            />
                                          </Card>
                                        </div> : null}
                                    </div>
                                    {/* {
                                  status === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT ?
                                    <div className="mb-1 mt-2 pb-5 space-y-1">
                                      <div>
                                        <label className="text-[#344054] font-medium text-xs">CC Email:</label>
                                      </div>
                                      <div className="relative">
                                        <input
                                          type="text"
                                          onChange={e => setEmail(e.target.value)}
                                          value={email}
                                          placeholder="Type Email address"
                                          className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:py-[0.625vw] py-[10px] xl:pr-[0.625vw] pr-[10px] pl-8 placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                                        />
                                        <i className="mailicon absolute left-3 top-3"></i>
                                      </div>
                                    </div>
                                    : ''
                                } */}



                                    {
                                      status === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN ? <>
                                        <div className="mb-10 px-5 py-3 grid grid-cols-2 gap-2 ">

                                          <Link to='#'
                                            onClick={() => {
                                              setFullApproverEdit(false)
                                            }}
                                            className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                                          ><i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>

                                          <button onClick={() => {
                                            // if (isApproveButtonDisable === false) {
                                            approveSelectedReport(transactionCycleReportId, Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN)
                                            setFullApproverEdit(false)
                                            // }
                                          }}
                                            disabled={approveBtnDisabled ? true : false}
                                            className="text-center  bg-[#EFF8FF] flex items-center tableBtn bg-white text-[#039855] border border-[#D0D5DD] radius8"
                                          ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Acknowledge</button>
                                        </div>
                                      </> : <>
                                        <div className="mb-10 px-5 py-3 grid grid-cols-3 gap-2 ">

                                          <Link to='#' onClick={() => {
                                            setFullApproverEdit(false)
                                          }} className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                                          ><i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>
                                          {
                                            isApproveButtonDisable === true ?
                                              < Link to='' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center text-[#D92D20]"
                                                onClick={() => {
                                                  setRejectVisible(true);
                                                  // setFullApproverEdit(false)
                                                }
                                                }
                                              ><i className="gusd-close mr-1" style={{ fontSize: '1rem' }}></i>Reject</Link>
                                              :

                                              < Link to='' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center text-[#D92D20]"
                                                //  onClick={() => saveGroupInfo()}
                                                onClick={() => {
                                                  handleRejectClick();
                                                  setRejectVisible(true);
                                                  // setFullApproverEdit(false)
                                                }
                                                }
                                              ><i className="gusd-close mr-1" style={{ fontSize: '1rem' }}></i>Reject</Link>

                                          }

                                          {
                                            <button onClick={() => {
                                              // if (isApproveButtonDisable === false) {
                                              approveSelectedReport(transactionCycleReportId, Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN)
                                              setFullApproverEdit(false)
                                              // }
                                            }}
                                              disabled={approveBtnDisabled ? true : false}
                                              className="text-center  bg-[#EFF8FF] flex items-center tableBtn bg-white text-[#039855] border border-[#D0D5DD] radius8"
                                            ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Approve</button>
                                          }
                                        </div>

                                      </>
                                    }
                                  </div>
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">

                          <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                            <div className="card custTable">

                              <Timeline value={approvalCompleteData}
                                opposite={(item) => <Tag
                                  severity={approveStatusOptions(item)} className="mr-2 relative top-[-5px]"
                                  value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                    <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                    <small className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</small>
                                    <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                    <div className="text-color-secondary text-[9px] ml-2">{item.approvedDate}</div>
                                  </div>} />

                            </div>
                          </div>
                        </div>
                      </div>
                    </Dialog >

                    {/* confirmation dialog */}

                    <Dialog header="" visible={confirmVisible} style={{ width: '30vw' }} onHide={() => { setConfirmVisible(false); setVisibleEdit(false); }} footer={footerContent}>
                      <p className="m-0 text-[#0487C8]">
                        <i className='pi pi-check-circle mr-2'></i>
                        <span className='font-medium text-[18px]'>Your changes has been saved in this report</span>
                      </p>
                    </Dialog>
                    {/* edit popup end */}

                  </div>

                  <SignatureDialog isVisible={signatureDialog}
                    onClickHandler={(image) => handleSignatureSelection(image)}
                    onCloseHandler={() => {
                      setSignatureDialog(false);
                      setAddSignature(false);
                    }}
                    username={loggedInUserData?.name}
                  />
                </div>
              </div>
            </div >


            {/* next full popup */}
            < Dialog className="relative reports-popup" visible={showNextPopUp} position="right" style={{ width: '100vw' }
            } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setShowNextPopUp(false)} draggable={false} resizable={false} >

              {/* <div className="p-10"><a href="#" id="add-family-open-btn"><i className="gusd-edit text-2xl"></i></a></div> */}
              < div className="fixed z-10 inset-0 overflow-y-auto styled-select" >
                <div className="flex items-start justify-center min-h-full h-full bg-[#FBFDFF]">
                  <div className="relative overflow-hidden transform transition-all w-full">
                    <div className="grid grid-cols-12 custmCols">
                      <div className="col-span-3 h-full sideBarLeft openSideDiv">
                        <button onClick={() => { setShowPreviewPopUp(false); setShowNextPopUp(false); BindList(); }} type="button" className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md" id="add-family-cancel-btn"><i className="gusd-arrow-line-right mr-[14px] xl:mr-[0.729vw]"></i> Back Home</button>
                        <div className="mt-[10px] xl:mt-[0.533vw] text-[#101828] text-[20px] xl:text-[0.833vw] font-medium">Stipend Form</div>
                        {/* <div className="mt-[10px] xl:mt-[0.533vw] text-[#101828] text-[20px] xl:text-[0.833vw] font-medium">Assignment 10102</div> */}
                        <div className="mt-[32px] xl:[1.667vw]">
                          <ul className="sideTabs">
                            <li><a href="#"
                              onClick={() => { setShowPreviewPopUp(false); SetPreviewAndEdit(false); SetBasicInfoPopUp(true) }} className={`${basicInfoPopUp === true ? "tab-b active activeCheck" : ""}`} data-id="tab1">
                              <i className="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i>
                              Basic Info</a></li>

                            <li><a href="#"
                              onClick={() => { SetBasicInfoPopUp(false); SetPreviewAndEdit(true) }}
                              className={`${previewAndEdit === true ? "tab-b active activeCheck" : null}`}
                              data-id="tab2"><i className="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i> Preview & Edit</a></li>

                          </ul>
                        </div>
                        <div className="fixed top-0 left-0 openBtn xl:hidden">
                          <button type="button" className="sideDivBtn inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#3366FF] border border-[#EFF8FF] rounded-r-md"><i className="gusd-arrow-line-right"></i></button>
                        </div>
                      </div>

                      <div className="col-span-12 sm:col-span-9 mScrollCstm overflow-auto custm_dropdown">
                        <div className="tab-c tab-active p-lr-110 pt-10 xl:pt-0 h-[40vw]" data-id="tab1">
                          {

                            basicInfoPopUp === true ?
                              <div>
                                <div className='flex items-center justify-center'>
                                  <div className='flex items-center gap-3'>
                                    <div><Image src={landing_logo} width={"100"} height={"100"} /></div>
                                    <div className='flex flex-col items-center justify-center'>
                                      <div><strong>GLENDALE UNIFIED SCHOOL DISTRICT</strong></div>
                                      <div><strong>“Preparing our students for their future”</strong></div>
                                      <div className='text-center'>
                                        <p>Office of the Chief Human Resources & Operations Officer</p>
                                        <p>223 North Jackson St., Glendale, California 91206-4380</p>
                                        <p>Telephone: 818-241-3111, Ext. 1256 • Fax: 818-547-3207</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="mCustomScrollbar scroll-w-10 max-h-100">

                                  <div className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] ">
                                    <form>
                                      <div className="col mt-2">
                                        <div className='grid grid-cols-12 items-end md:gap-2 mt-5'>
                                          <div className='col-span-12 md:col-span-1'><label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block" htmlFor="username">Form Title<span className='text-[red] pl-0.2'>*</span></label></div>
                                          <div className='col-span-12 md:col-span-11'>

                                            {/* <input value={formTitle} onChange={e => { setFormTitle(e.target.value) }} name="" className="text-[16px] xl:text-[0.833vw] px-[14px] md:py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw] mt-2" placeholder="Form Title" style={{ border: '0', background: 'none', borderBottom: '1px', borderColor: '#000', borderStyle: 'solid', borderRadius: '0' }} /> */}
                                            <input value={formTitle} onChange={e => { setFormTitle(e.target.value) }}
                                              disabled name="" className="text-[16px] xl:text-[0.833vw] px-[14px] md:py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw] mt-2" placeholder="Form Title" style={{ border: '0', background: 'none', borderBottom: '1px', borderColor: '#000', borderStyle: 'solid', borderRadius: '0' }} />

                                          </div>
                                        </div>
                                      </div>

                                      <div className="col mt-2">
                                        <div className='grid grid-cols-12 items-end md:gap-2 mt-5'>
                                          <div className='col-span-12 md:col-span-1'><label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block" htmlFor="username">School Name<span className='text-[red] pl-0.2'>*</span></label></div>
                                          <div className='col-span-12 md:col-span-11'>
                                            <Dropdown value={location} onChange={(e) => {
                                              setLocation(e.value);
                                            }} options={locationList} optionLabel="name" placeholder="Select here"
                                              filter
                                              showClear
                                              className="w-full md:w-14rem" />
                                          </div>
                                        </div>
                                      </div>

                                      <div className='grid grid-cols-12 items-end md:gap-8 mt-2'>
                                        <div className='col-span-12 md:col-span-1'><label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block" htmlFor="username">School Year<span className='text-[red] pl-0.2'>*</span></label></div>
                                        <div className='col-span-12 md:col-span-5'>

                                          <Dropdown value={schoolYearId} onChange={(e) => {
                                            setSchoolYearId(e.value);
                                          }}
                                            options={schoolYearArray} optionLabel="name" placeholder="Select here"
                                            filter
                                            showClear
                                            className="w-full md:w-14rem" />
                                        </div>
                                        <div className='col-span-12 md:col-span-1'><label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block" htmlFor="username">Semester<span className='text-[red] pl-0.2'>*</span></label></div>
                                        <div className='col-span-12 md:col-span-5'>

                                          <Dropdown value={semisterId} onChange={(e) => {
                                            setSemisterId(e.value);
                                          }}
                                            options={semisterArray} optionLabel="name" placeholder="Select here"
                                            filter
                                            showClear
                                            className="w-full md:w-14rem" />
                                        </div>
                                      </div>

                                      <div className="col mt-2">

                                        <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" htmlFor="username" >Stipend Type:</label>

                                        {confirmed.map((title) => {
                                          return (<>
                                            <div className="flex flex-column gap-3">
                                              <Checkbox inputId={title.key} name="title" value={title} onChange={onConfirmationChange} checked={selectedConfirmation.some((item) => item.key === title.key)} />
                                              <label className="mt-15 text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block" htmlFor={title.key}>
                                                {title.name}
                                              </label>
                                            </div>
                                          </>
                                          );
                                        })}

                                      </div>

                                      <div className='grid grid-cols-2 gap-8 mt-2'>
                                        <div className='col  '>
                                          <label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block" htmlFor="username">Employee's Name:<span className='text-[red] pl-0.2'>*</span></label>
                                          <div className='flex  '>
                                            <Dropdown value={employeeId} onChange={(e) => {
                                              setEmployeeId(e.target.value);
                                              setEmployeeCodeOnly(e.target.value.name.match(/\d+/)[0]);
                                            }}
                                              options={allApproverList} optionLabel="name" placeholder="Select here"
                                              filter
                                              showClear
                                              onKeyDown={e => {
                                                userList(e)
                                              }}
                                              className="w-full md:w-14rem" />
                                            {/*  <div onClick={(e) => setOpenNewEmployee(true)} className='cursor-pointer text-[30px] '>
                                             
                                              <Tooltip target=".icon-tooltip" content="Add Employee" position="top" className="custom-tooltip-content" />
                                              <i className='icon-tooltip gusd-pluse-circle' style={{ color: "lightgray", fontSize: "20px", margin: "3px", position: "relative", bottom: "6px" }}></i>
                                            </div> */}
                                          </div>

                                        </div>
                                        {/* Add New Employee Popup */}
                                        {/* <Dialog
                                          header="Add New Employee"
                                          visible={openNewEmployee}
                                          style={{ width: "30vw" }}

                                          onHide={() => {
                                            setOpenNewEmployee(false);

                                          }}
                                        // footer={footerContentForReqReject}
                                        >
                                          <div className="m-0">

                                            <div className="font-medium text-[18px] mb-2 mt-3">School/Department <span className="text-[red] pl-0.2">*</span></div>
                                            <Dropdown id="dept" value={NewEmployeeSchool}
                                              onChange={(e) => { setNewEmployeeSchool(e.value) }}
                                              filter
                                              // disabled={disabled}
                                              options={schoolList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                            <div className="font-medium text-[18px] mb-2 mt-3">Employee Name <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                              value={NewEmployeeName}
                                              placeholder=""
                                              onChange={e => { setNewEmployeeName(e.target.value) }}
                                              className="w-full"
                                            />
                                            <div className="font-medium text-[18px] mb-2 mt-3">Employee Code <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                              value={NewEmployeeCode}
                                              placeholder=""
                                              onChange={e => { setNewEmployeeCode(e.target.value) }}
                                              className="w-full"
                                            />

                                            <div className="font-medium text-[18px] mb-2 mt-3 ">Employee Email Address <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                              value={NewEmployeeEmail}
                                              placeholder=""
                                              onChange={e => { setNewEmployeeEmail(e.target.value) }}
                                              className="w-full"
                                            />
                                          </div>
                                          <div className='flex justify-between gap-2 mt-3'>
                                            <Link to="" onClick={() => { setOpenNewEmployee(false); }}
                                              className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                              <i class="pi pi-times"></i><span>Cancel</span></Link>

                                            <Link to="" onClick={() => { AddNewEmployee() }}
                                              className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                              <i class="pi pi-check"></i><span>Add</span></Link>

                                          </div>
                                        </Dialog> */}
                                        <div className='col '>
                                          <label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block" htmlFor="username">Employee ID:<span className='text-[red] pl-0.2'>*</span></label>

                                          <input value={employeeCodeOnly} disabled={true} name="" className="text-[16px] xl:text-[0.833vw] px-[14px] md:py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw] mt-2" placeholder="Employee ID" style={{ border: '0', background: 'none', borderBottom: '1px', borderColor: '#000', borderStyle: 'solid', borderRadius: '0' }} />
                                        </div>
                                      </div>

                                      <div className='mt-2'>
                                        <div className="grid grid-cols-2 lg:grid-cols-12 items-end">
                                          {
                                            assignmentArray.map((item, index) => {
                                              return (
                                                <>
                                                  <div className='col-span-12 md:col-span-1'>
                                                    <label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block font-bold" htmlFor="Assign">Assignment #{index + 1}: </label>
                                                  </div>
                                                  <div className="col-span-12 md:col-span-5">
                                                    <input value={item.name} onChange={e => { onChangeAssignment(index, e.target.value, 'N') }} name="" className="text-[16px] xl:text-[0.833vw] px-[14px] md:py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw] mt-2" placeholder="Assignment Name" style={{ border: '0', background: 'none', borderBottom: '1px', borderColor: '#000', borderStyle: 'solid', borderRadius: '0' }} />

                                                  </div>
                                                  <div className="col-span-12 md:col-span-1 max-md:mt-5"><label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block" htmlFor="username">Amount:</label></div>
                                                  <div className="col-span-12 md:col-span-5">
                                                    <input value={item.amount} onChange={e => { onChangeAssignment(index, e.target.value, 'A') }} name="" className="text-[16px] xl:text-[0.833vw] px-[14px] md:py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw] mt-2" placeholder="Amount" style={{ border: '0', background: 'none', borderBottom: '1px', borderColor: '#000', borderStyle: 'solid', borderRadius: '0' }} />
                                                  </div>
                                                  <div className="col-span-12 md:col-span-1 max-md:mt-5">
                                                    <label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block" htmlFor="isSplit">
                                                      <Checkbox onChange={e => { onChangeAssignment(index, e, 'S') }} checked={item.isSplit} className='mr-1' />  Split</label>
                                                  </div>
                                                  <div className="col-span-12 md:col-span-4 h-[50px]">
                                                    {item.isSplit === true ?
                                                      <input value={item.splitText} onChange={e => { onChangeAssignment(index, e.target.value, 'ST') }} name="" className="text-[16px] xl:text-[0.833vw] px-[14px] md:py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw] mt-2" placeholder="Enter your text" style={{ border: '0', background: 'none', borderBottom: '1px', borderColor: '#000', borderStyle: 'solid', borderRadius: '0' }} />
                                                      : null
                                                    }
                                                  </div>
                                                  <div className="col-span-12 md:col-span-2 max-md:mt-5">
                                                    <label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block" htmlFor="isDeptChair">
                                                      <Checkbox onChange={e => { onChangeAssignment(index, e, 'DC') }} checked={item.isDeptChair} className='mr-1' /> Department Chair</label>
                                                  </div>
                                                  <div className="col-span-12 md:col-span-5 h-[50px]">
                                                    {item.isDeptChair === true ?
                                                      <input value={item.noOfEmployee} onChange={e => { onChangeAssignment(index, e.target.value, 'DCT') }} name="" className="text-[16px] xl:text-[0.833vw] px-[14px] md:py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw] mt-2" placeholder="No. Of Employee" style={{ border: '0', background: 'none', borderBottom: '1px', borderColor: '#000', borderStyle: 'solid', borderRadius: '0' }} />
                                                      : null
                                                    }
                                                  </div>
                                                  <div className="col-span-12 md:col-span-6 max-md:mt-5 ">
                                                    <label className="text-[#344054] text-[14px] xl:text-[0.829vw] font-medium xl:mb-[0.521vw] inline-block mt-3 md:py-[10px]" htmlFor="isExtraCurricular">
                                                      <Checkbox onChange={e => { onChangeAssignment(index, e, 'E') }} checked={item.isExtraCurricular} className='mr-1' /> Extra Curricular</label>
                                                  </div>
                                                  <div className="col-span-12 md:col-span-6 max-md:mt-5 ">
                                                    {index !== 0 &&
                                                      <div className='flex flex-row-reverse mt-2'>
                                                        <Link onClick={(e) => { onClickRemoveAssignment(index) }} className='py-2 px-6 bg-red-700 mb-6 text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:border-[#1570EF]'>
                                                          Remove</Link>
                                                      </div>
                                                    }
                                                  </div>
                                                </>
                                              )
                                            })
                                          }
                                        </div>
                                        <a href="#" onClick={() => {
                                          onClickAddAssignment();
                                        }} className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] mt-2">
                                          Add</a>
                                      </div>


                                      {/* <div className='grid grid-cols-2 gap-8 mt-2'>
                                                                                    <div className='col '>
                                                                                        <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" htmlFor="username">Type<span className='text-[red] pl-0.2'>*</span></label>
                                                                                        <Dropdown value={departmentId} onChange={(e) => {
                                                                                            setDepartmentId(e.value);
                                                                                        }}
                                                                                            options={departmentArray} optionLabel="name" placeholder="Select here"
                                                                                            filter
                                                                                            className="w-full md:w-14rem" />
                                                                                    </div>
                                                                                    <div className='col '>
                                                                                        <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" htmlFor="username"># of people in the Department<span className='text-[red] pl-0.2'>*</span></label>


                                                                                        <input onChange={e => setDepartmentPeopleCount(e.target.value)} value={departmentPeopleCount} type="text" name="" className="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]" placeholder="Enter here" />
                                                                                    </div>
                                                                                    <div className="col mt-2">
                                                                                        <div className="flex flex-column gap-3">
                                                                                            <Checkbox onChange={onSelfAssignChanged} checked={selfAssign} />
                                                                                            <label className="mt-15 text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" htmlFor='selfassign'>
                                                                                                Self Assign
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div> */}
                                      <div className={"mb-8"}>
                                        <div style={{ marginTop: '10px' }}>
                                          <div>
                                            <table style={{ width: "100%", fontSize: "14px" }}>
                                              <tbody>
                                                <tr>
                                                  <td width={"150px"} style={{ padding: "10px" }} className='text-[#344054] text-[14px] xl:text-[0.829vw] font-medium'>Principal<span className="text-[red] pl-0.2">*</span></td>
                                                  <td style={{ padding: "5px" }}>
                                                    {/*  {!selectedEmployee ? ( 
                                                <Dropdown
                                                   disabled
                                                   placeholder="Select an Site Admin/ Dept Head"
                                                   className="w-full md:w-14rem"
                                                   />
                                                ) : ( */}
                                                    <Dropdown
                                                      value={selectedPrincipal}
                                                      onChange={e => {
                                                        setSelectedPrincipal(e.value);
                                                      }}
                                                      options={approverList}
                                                      optionLabel="name"
                                                      placeholder="Select a Principal"
                                                      filter
                                                      showClear
                                                      onKeyDown={e => {
                                                        approversList(e)
                                                      }}
                                                      className="w-full md:w-14rem"
                                                    />
                                                    {/*  )} */}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style={{ padding: "10px" }} className='text-[#344054] text-[14px] xl:text-[0.829vw] font-medium'>HR Technician<span className="text-[red] pl-0.2">*</span></td>
                                                  <td style={{ padding: "5px" }}>
                                                    {/* <Dropdown
                                                      value={selectedHRTechnician}
                                                      onChange={e => setSelectedHRTechnician(e.value)}
                                                      options={hrList}
                                                      optionLabel="name"
                                                      placeholder="Select a HR Technician"
                                                      onKeyDown={e => {
                                                        setEmpList(e, "HR")
                                                      }}
                                                      filter
                                                      className="w-full md:w-14rem"
                                                    /> */}
                                                    <input value={selectedHRTechnician} onChange={e => { setSelectedHRTechnician(e.target.value) }}
                                                      disabled name="" className="text-[16px] xl:text-[0.833vw] px-[14px] md:py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw] mt-2" placeholder="Form Title" style={{ border: '0', background: 'none', borderBottom: '1px', borderColor: '#000', borderStyle: 'solid', borderRadius: '0' }} />

                                                    {/* <InputText disabled
                                                      value={selectedHRTechnician}
                                                      placeholder=""
                                                      onChange={e => { setSelectedHRTechnician(e.target.value) }}
                                                      className="w-full md:w-14rem"
                                                    /> */}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style={{ padding: "10px" }} className='text-[#344054] text-[14px] xl:text-[0.829vw] font-medium'>Executive Manager<span className="text-[red] pl-0.2">*</span></td>
                                                  <td style={{ padding: "5px" }}>
                                                    <Dropdown
                                                      value={selectedExecutiveManager}
                                                      onChange={e => {
                                                        setSelectedExecutiveManager(e.value);
                                                      }}
                                                      options={approverList}
                                                      onKeyDown={e => {
                                                        approversList(e)
                                                      }}
                                                      optionLabel="name"
                                                      placeholder="Select a Executive Manager"
                                                      filter
                                                      showClear
                                                      className="w-full md:w-14rem"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 mt-[40px] xl:mt-[2.083vw]">
                                  <div>
                                    <a href="#" onClick={() => { setShowPreviewPopUp(false); setShowNextPopUp(false); BindList(); }} className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"><i className='gusd-arrow-line-right mr-1'></i>Previous</a>
                                  </div>
                                  <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                                    {/*  {btnStatus === !Request_Stipend_Status.PENDING || btnDisabled ? <a
                                      href="#" disabled={btnDisabled} className={`${(btnDisabled) ? 'gray ' : 'blue '} inline-block text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium border border-[#EFF8FF] bg-[#EFF8FF] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]`}><i className='pi pi-save mr-1' style={{ fontSize: '0.8rem' }}></i>Save</a> : <a
                                        onClick={() => {
                                          saveBasicInfo(Request_Stipend_Status.PENDING);
                                        }}
                                        href="#" disabled={btnDisabled} className={`${(btnDisabled) ? 'gray ' : 'blue '} inline-block text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium border border-[#EFF8FF] bg-[#EFF8FF] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]`}><i className='pi pi-save mr-1' style={{ fontSize: '0.8rem' }}></i>Save</a>
                                    } */}
                                    <a
                                      onClick={() => {
                                        saveBasicInfo(Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE);
                                      }}
                                      href="#" className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] ">Submit </a>
                                    {
                                      (showPreviewPopUp) ?
                                        <a href="#" onClick={() => {
                                          saveBasicInfo(Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE);
                                        }
                                        } className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] ">
                                          <i className='gusd-check mr-1'></i>Submit </a> :

                                        <a href="#" onClick={() => {
                                          SetPreviewAndEdit(true); SetBasicInfoPopUp(false);
                                        }} className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] ">
                                          <i className='gusd-eye mr-1'></i>Preview</a>
                                    }
                                  </div>
                                </div>
                              </div> : null
                          }

                          {
                            previewAndEdit === true ?
                              <div>
                                <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]'>
                                  {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                  <StipendFormPdf ref={componentRef}
                                    data={{
                                      'schoolName': location.name,
                                      'schoolYear': schoolYearId.name,
                                      'schoolSemister': semisterId.name,
                                      'employeeName': employeeId.name,
                                      'departmentTypeName': departmentId.name,
                                      'departmentCount': departmentPeopleCount,
                                      'assignmentArray': assignmentArray,
                                      'stipendTypes': confirmed,
                                      'previewAndEdit': previewAndEdit,
                                      'selectedConfirmation': selectedConfirmation,
                                      'approvalFinalData': approvalCompleteData,
                                    }}
                                  />
                                </div>
                                <div className="grid grid-cols-2 mt-[40px] xl:mt-[2.083vw]">
                                  <div>
                                    <a href="#" onClick={() => { setShowPreviewPopUp(false); SetPreviewAndEdit(false); SetBasicInfoPopUp(true) }} className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"><i className='gusd-arrow-line-right mr-1'></i>Previous</a>
                                  </div>
                                  <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                                    {/*  {btnDisabled ?
                                      <a
                                        href="#" disabled={btnDisabled || !Request_Stipend_Status.PENDING} className={`${(btnDisabled || !Request_Stipend_Status.PENDING) ? 'gray ' : 'blue '} inline-block text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium border border-[#EFF8FF] bg-[#EFF8FF] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]`}

                                      ><i className='pi pi-save mr-1' style={{ fontSize: '0.8rem' }}></i>Save</a> : <a
                                        onClick={() => {
                                          saveBasicInfo(Request_Stipend_Status.PENDING);
                                        }}
                                        href="#" disabled={btnDisabled || !Request_Stipend_Status.PENDING} className={`${(btnDisabled || !Request_Stipend_Status.PENDING) ? 'gray ' : 'blue '} inline-block text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium border border-[#EFF8FF] bg-[#EFF8FF] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]`}

                                      ><i className='pi pi-save mr-1' style={{ fontSize: '0.8rem' }}></i>Save</a>
                                    } */}

                                    <a href="#" onClick={() => {
                                      saveBasicInfo(Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE);
                                      setPreviewSubmit(true)
                                      // setShowPreviewPopUp(true)
                                    }
                                    } className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] ">
                                      <i className='gusd-check mr-1'></i>Submit </a>
                                  </div>
                                </div>
                              </div> : null
                          }

                        </div>

                      </div>

                      {/* confirmation dialog */}

                      <Dialog header="" visible={confirmVisible2} style={{ width: '30vw' }} onHide={() => { setConfirmVisible2(false); setVisibleEdit(false); }} footer={footerContent1}>
                        <p className="m-0 text-[#0487C8]">
                          <i className='pi pi-check-circle mr-2'></i>
                          <span className='font-medium text-[18px]'>This report Has been Successfully Created</span>
                        </p>
                      </Dialog>

                    </div>
                  </div>
                </div>

              </div >
            </Dialog >

            {/* Reject dialog */}
            < Dialog
              header="Reject Report"
              visible={rejectVisible}
              style={{ width: "30vw" }}
              //                      closable={false}
              onHide={() => {
                setRejectVisible(false)
                setFallBackApproverLevel('')
                setFallBackApprover('')
                setFallBackApproverId('');
                setRejectValueMsg('')
                // setVisibleEdit(false);
              }}
              footer={footerContentForReqReject}
            >
              <div className="m-0">
                {sendMsg && <div className="font-medium text-[18px] text-[#249144] mb-6">Message Sent Successfully</div>}

                <div className="font-medium text-[18px] mb-3">Select an approver level<span className="text-[red] pl-0.2">*</span></div>
                <Dropdown
                  value={fallBackApproverLevel}
                  options={approverLevelForReject}
                  onChange={(e) => {
                    getApprover(e.value);
                  }}
                  optionLabel="label"
                  placeholder="Select"
                  showClear
                  className="p-column-filter custDropdown w-full mb-6"
                />

                {/*  <div className="font-medium text-[18px] mb-3">Select an approver<span className="text-[red] pl-0.2">*</span></div>

                <Dropdown
                  value={fallBackApprover}
                  options={approversOptions}
                  onChange={(e) => setFallBackApprover(e.value)}
                  optionLabel="label"
                  placeholder="Select"
                  className="p-column-filter custDropdown w-full mb-6"
                /> */}

                <div className="font-medium text-[18px] mb-3">Approver<span className="text-[red] pl-0.2">*</span></div>

                <InputText
                  value={fallBackApprover} disabled
                  placeholder="Auto populate by select approver level"
                  onChange={e => { setFallBackApprover(e.value) }}
                  className="p-column-filter w-full mb-6 mt-3"
                />

                <div className="font-medium text-[18px] mb-3 mt-3">Enter the Reason for Rejection<span className="text-[red] pl-0.2">*</span></div>

                <InputText
                  value={rejectMsgValue}
                  placeholder="Enter the Reason for Rejection"
                  onChange={e => setRejectValueMsg(e.target.value)}
                  className="w-full"
                />
              </div>
            </Dialog >

          </Layout >
        )
        }
      </ReactFullscreen >
    </>
  ) : (
    <Login sessionExpired={1} />
  );
}